export default {
    login: {
        username: '用户名'
    },
    "文件大小不能超过 4Mb": "文件大小不能超过 4Mb",
    "如果您已是商家，请": "如果您已是賣家，請",
    "请输入用户名": "請輸入用戶名",
    "点击登陆": "點擊登錄",
    'bonus': '投资收益',
    'exchange-usdt': '积分兑换余额',
    'cancel': '投资订单取消',
    'returns': '理财返本',
    'rebate': '佣金',
    'otc-in': 'OTC订单出售',
    'otc-out': '驳回OTC订单申请',
    'recharge': '充值',
    'withdraw': '提现',
    'pay-order': '支付订单/商品购买',
    'jackpot': '彩金赠送',
    'title': '這是標題',
    '请输入正确的手机号码': '请输入正确的手机号码',
    'titleInfo': '我們的合作夥伴計劃為您提供全方位的營銷支持和服務，我們的客戶服務團隊將提供專業的支持和建議，幫助您優化您的產品展示和銷售策略。',
    'titleInfo1': '現在就加入我們吧！讓我們一起創造更大的商業機會，共同成長！',
    '该手机号已被占用，请绑定其他手机号': '該手機號已被占用，請綁定其他手機號',
    ///登注
    '登录': '登錄',
    '注册': '註冊',
    '账号': '賬號',
    '手机号': '手機號',
    '密码': '密碼',
    '邀请码': '邀請碼',
    '邀请好友，共同赚钱': '邀請好友，共同赚钱',
    '最高享': '最高享',
    '返利': '返利',
    '请去设置开启相册访问权限': '請去設置開啟相冊訪問權限',
    '要限制5M以内': '要限制5M以内',
    '请输入账号': '請輸入賬號',
    '请输入手机号': '請輸入手機號',
    '请输入密码': '請輸入密碼',
    '请输入邀请码': '請輸入邀請碼',

    '忘记密码？': '忘記密碼？',
    '还没有账号？': '還沒有賬號？',
    '去注册': '去註冊',
    '已有账号？': '已有賬號？',
    '去登录': '去登錄',
    '请登录': '請登錄',

    '注册成功': '註冊成功',
    '登录成功': '登錄成功',
    '安全验证': '安全验证',

    '暂无数据': '暫無數據',
    '暂无记录': '暫無记录',

    '请输入消息内容': '請輸入消息內容',
    '你好，欢迎来到我们的平台': '你好，歡迎來到我們的平台!',
    '历史消息': '歷史消息',
    '请输入您的消息...': '請輸入您的消息...',
    ///充值
    '预计到账': '預計到賬',
    '当前汇率': '當前匯率',
    '充值记录': '充值記錄',
    '选择支付方式': '選擇支付方式',
    '请如实填写实际转账金额，否则可能导致系统审核无法通过，影响充值进度。': '請如實填寫實際轉賬金額，否則可能導致系統審核無法通過，影響充值進度。',
    '区块链网络': '區塊鍊網絡',
    '充值地址': '充值地址',
    '充值数量': '充值數量',
    '请输入充值数量': '請輸入充值數量',
    '上传图片（上传支付详情截图）': '上傳圖片（上傳支付詳情截圖）',
    '保存二维码': '保存二維碼',
    '提交': '提交',
    '订单号': '訂單號',
    '创建时间': '創建時間',
    '充值金额': '充值金額',
    '状态': '狀態',
    '详情': '詳情',
    '币种协议': '幣種協議',
    '收款地址': '收款地址',
    '订单状态': '訂單狀態',
    '付款凭证': '付款憑證',
    '提交成功': '提交成功',
    '提交成功，如有疑问联系客服': '提交成功，如有疑問聯繫客服',
    '返回首页': '返回首頁',
    '查看记录': '查看記錄',
    '提现记录': '提現記錄',
    "快速提币": '快速提幣',
    "提币到数字币地址": '提幣到數字幣地址',
    "地址": '地址',
    '请输入金额': '请輸入金額',
    "币种": '幣種',
    "文件大小不能超过 10Mb": '文件大小不能超過 10Mb',
    '请求错误': '請求錯誤',
    '未授权，请登录': '未授權，請登錄',
    '拒绝访问': '拒絕訪問',
    '请求地址不存在:': '請求地址不存在:',
    '请求超时': '請求超時',
    '服务器内部错误': '服務器內部錯誤',
    '服务未实现': '服務未實現',
    '网关错误': '網關錯誤',
    '服务不可用': '服務不可用',
    '网关超时': '網關超時',
    'HTTP版本不受支持': 'HTTP版本不受支持',
    '网络波动请刷新页面': '網絡波動請刷新頁面',

    ///任务
    '余额': '餘額',
    '归还本金': '歸還本金',
    '冻结订单': '凍結訂單',
    '冻结金额': '凍結金額',
    '今日任务': '今日任務',
    '今日收入': '今日收入',
    '累计收入': '累計收入',
    '恭喜抢单成功': '恭喜搶單成功',
    '任务编号': '任務編號',
    '下单日期': '下單日期',
    '订单总额': '訂單總額',
    '佣金总额': '訂單總額',
    '预计返还': '預計返還',
    '查看订单': '查看訂單',
    '您尚未添加收货地址': '您尚未添加收貨地址',
    '奖励': '獎勵',
    '本产品来自': '本產品來自',
    '需支付': '需支付',
    '下单时间': '下单时间',
    '剩余时间': '剩餘時間',
    '返佣时间': '返佣時間',
    '解冻时间': '解凍時間',
    '任务状态': '任務狀態',
    '进行中': '進行中',
    '已支付': '已支付',
    '冻结中': '凍結中',
    '已完成': '已完成',
    '立即支付': '立即支付',
    '解冻': '解冻',
    '选择收货地址': '選擇收貨地址',
    '新增地址': '新增地址',
    "去添加地址吧": '去添加地址吧',
    '默认': '默認',
    "姓名": '姓名',
    '请输入姓名': '請輸入姓名',
    '请输入地址': '請輸入地址',
    '设为默认地址': '設為默認地址',
    '保存': '保存',
    '任务提交成功，如有疑问联系客服': '任務提交成功，如有疑問聯繫客服',
    "添加成功": '添加成功',
    '修改成功': '修改成功',
    "删除成功": '刪除成功',
    '解冻成功，已退款至您的余额！': '解凍成功，已退款至您的餘額！',
    '支付成功': '支付成功',

    '下拉刷新': '下拉刷新',
    '刷新完成': '刷新完成',
    '刷新中...': '刷新中...',
    '上拉加载': '上拉加載',
    '加载中...': '加載中...',
    '加载完毕': '加載完畢',
    '没有更多啦': '沒有更多啦',
    '佣金记录': '佣金記錄',
    '个人返佣': '個人返佣',
    '团队返佣（一级）': '團隊返佣（一級）',
    '团队返佣（二级）': '團隊返佣（二級）',
    '团队返佣（三级）': '團隊返佣（三級）',
    '全部': '全部',
    '系统加款': '系統加款',
    '系统扣款': '系統扣款',
    'vip充值/购买': 'vip充值/購買',
    '解冻订单': '解凍訂單',
    '支付订单/商品购买': '支付訂單/商品購買',
    '彩金赠送': '彩金贈送',
    '钱包余额': '錢包餘額',
    '明细': '明細',
    '资金记录': '資金記錄',
    '语言': '語言',
    '下载': '下載',
    '设置': '設置',
    '登录密码': '登錄密碼',
    '重置密码': '重置密碼',
    '原密码': '原密碼',
    '请输入原密码': '請輸入原密碼',
    '新密码': '新密碼',
    '请输入新密码': '請輸入新密碼',
    '再次输入新密码': '再次輸入新密碼',
    '请再次输入新密码': '請再次輸入新密碼',
    '设置资金密码': '設置資金密碼',
    '请输入6位数字密码': '請輸入6位數字密碼',
    '再次输入密码': '再次輸入密碼',
    '请再次输入6位数字密码': '請再次輸入6位數字密碼',
    '重置资金密码': '重置資金密碼',
    '旧资金密码': '舊資金密碼',
    '请输入6位数字旧密码': '請輸入6位數字舊密碼',
    '新资金密码': '新資金密碼',
    '请输入6位数字新密码': '請輸入6位數字新密碼',
    '再次输入新资金密码': '再次輸入新資金密碼',
    '再次输入6位数字新密码': '再次輸入6位數字新密碼',
    '收货地址': '收貨地址',
    '收货地址管理': '收貨地址管理',
    '编辑': '编辑',
    '删除': '刪除',
    '退出': '退出',
    '语言设置': '語言設置',
    '检测更新': '檢測更新',
    '客服': '客服',
    '查看详情': '查看详情',
    "保存失败": '保存失敗',
    "请上传图片": '請上傳圖片',
    "请输入转账地址": '請輸入轉賬地址',
    '任务返佣': '任務返佣',
    ///service
    '手机号不能为空': '手機號不能為空',
    '联系人不能为空': '收貨不能為空',
    '地址不能为空': '地址不能為空',
    '收货地址达上限': '收貨地址達上限',
    '添加失败': '添加失敗',
    '非法请求': '非法請求',
    '地址不存在,或者已删除': '地址不存在,或者已刪除',
    '抢单正在进行中': '搶單正在進行中',
    '抢单失败请联系客服': '搶單失敗請聯繫客服',
    '订单不存在': '訂單不存在',
    '解锁失败,请联系客服': '解鎖失敗,請聯繫客服',
    '支付失败,请联系客服': '支付失敗,請聯繫客服',
    '操作失败,请联系客服': '操作失敗,請聯繫客服',
    '抢单次数不足,请升级VIP': '搶單次數不足,請升級VIP',
    '当前余额无法抢单': '當前餘額無法搶單',
    '商品库存不足': '商品庫存不足',
    '正在执行中': '正在執行中',
    '该订单无需解锁': '該訂單無需解鎖',
    '该订单无法解锁,请联系管理员': '該訂單無法解鎖,請聯繫管理員',
    '未满足解锁时间,无法解锁': '未滿足解鎖時間,無法解鎖',
    '操作失败，请稍后再试': '操作失敗，請稍後再試',
    '请设置资金密码': '請設置資金密碼',
    '资金密码错误': '資金密碼錯誤',
    '资金密码不能为空': '資金密碼不能為空',
    '资金密码必须6-12位': '資金密碼必須6-12位',
    '该订单未满足支付条件': '該訂單未滿足支付條件',
    '请添加收货地址': '請添加收貨地址',
    '余额不足': '餘額不足',
    '非法操作': '非法操作',
    '删除失败': '刪除失敗',

    '支付失败，无法购买低等级会员': '支付失敗，無法購買低等級會員',
    '账号余额不足': '賬號餘額不足',
    '金额不能为空': '金額不能為空',
    '会员等级不能为空': '會員等級不能為空',
    '有效天数不能为空': '有效天數不能為空',
    '购买成功': '購買成功',
    '系统错误': '系統錯誤',
    'vip等级不足': 'vip等級不足',
    '提款金额不得低于最低提款': '提款金額不得低於最低提款',
    '提款金额不得高于最高提款': '提款金額不得高於最高提款',
    '有冻结中订单未完成': '有凍結中訂單未完成',
    '有未完成的订单': '有未完成的訂單',
    '不满足每日提现要求': '不滿足每日提現要求',
    '超过提现次数': '超過提現次數',
    '不在提现时间范围内，请稍后再试': '不在提現時間範圍內，請稍後再試',
    '请稍后再试': '請稍後再試',
    '无权限': '無權限',
    '渠道未开通': '渠道未開通',
    '提交失败，当前有未处理订单': '提交失敗，當前有未處理訂單',
    '充值链错误': '充值鏈錯誤',
    '充值价值不得小于最小充值金额': '充值價值不得小於最小充值金額',
    '充值价值不得大于最大充值金额': '充值價值不得大於最大充值金額',
    '系统错误，请稍后重试': '系統錯誤，請稍後重試',
    '重复提交': '重複提交',
    '用户名不能为空': '用戶名不能為空',
    '登录密码不能为空': '登錄密碼不能為空',
    '用户名必须由数字和英文字母组成': '用戶名必須由數字和英文字母組成',
    '用户名不符合设定': '用戶名不符合設定',
    '邀请码不能为空': '邀請碼不能為空',
    '邀请码无效': '邀請碼無效',
    '用户名重复': '用戶名重複',
    '请输入正确的邮箱地址': '請輸入正確的郵箱地址',
    '操作失败！修正后账户余额小于0': '操作失敗！修正後賬戶餘額小於0',
    // "程序错误": '程序錯誤',
    '登录密码必须6-12位': '登錄密碼必須6-12位',
    "类型不能为空": '類型不能為空',
    // "密码必须6-12位": '密碼必須6-12位',
    '确认密码不能为空': '確認密碼不能為空',
    '验证码不能为空': '驗證碼不能為空',
    '两次输入密码不一致': '兩次輸入密碼不一致',
    '验证码错误': '驗證碼錯誤',
    '该用户不存在': '該用戶不存在',
    '用户不存在': '該用戶不存在',
    '验证类型不能为空': '驗證類型不能為空',
    '未绑定手机号': '未綁定手機號',
    '未绑定邮箱': '未綁定郵箱',
    '未绑定谷歌验证器': '未綁定谷歌驗證器',
    '验证码不正确': '驗證碼不正確',
    '密码必须6-12位': '密碼必須6-12位',
    '密码不能为空': '密碼不能為空',
    '资金密码必须是6位': '資金密碼必須是6位',
    '新密码不能为空': '新密碼不能為空',
    '旧密码不能为空': '舊密碼不能為空',
    '新密码确认不能为空': '新密碼確認不能為空',
    '密码不正确': '密碼不正確',
    '此手机号已被使用': '此手機號已被使用',
    '电话号码不能为空': '電話號碼不能為空',
    '电话号码格式错误': '電話號碼格式錯誤',
    '密码位数限定为6-12位': '密碼位數限定為6-12位',
    ///小明
    '区块链任务接单平台': '區塊鏈任務接單平台',
    '下载客户端': '下載客戶端',
    'Single Dog是一个开创性区块链投资理财金融平台。为您精选定期、活期、基金、信托、资管、保险、债券及P2P等不同市场领域不同风险等级投资产品，让您的资金托管安全无忧，收益无忧。': 'Single Dog是一個開創性區塊鏈投資理財金融平台。為您精選定期、活期、基金、信託、資管、保險、債券及P2P等不同市場領域不同風險等級投資產品，讓您的資金託管安全無憂，收益無憂。',
    '关于我们': '關於我們',
    '是一个开创性区块链任务接单平台。为商家提供商品销量，同时给个人者提供安全、丰富的全职与兼职任务信息，通过领取任务轻松获得收益。': '是一個開創性區塊鏈任務接單平台。為商家提供商品銷量，同時給個人者提供安全、豐富的全職與兼職任務信息，通過領取任務輕鬆獲得收益.',
    '任务流程': '任務流程',
    '任务分配': '任務分配',
    '支付商品': '支付商品',
    '领取佣金': '領取佣金',
    '商家审核': '商家審核',
    '技术优势': '技術優勢',
    '高效撮合引擎，高性能、高稳定性': '高效撮合引擎，高性能、高穩定性',
    '"冷钱包双机制"的智能财务系统': '"冷錢包雙機制"的智能財務系統',
    '自动风控技术': '自動風控技術',
    '提现秒级到账、智能监控': '提現秒級到賬、智能監控',
    '独立的资产保险库，保障资金安全': '獨立的資產保險庫，保障資金安全',
    '区块链混币技术': '區塊鏈混幣技術',
    '合规经营牌照': '合規經營牌照',
    '联系我们': '聯繫我們',
    '官方地址': '官方地址',
    '安全检测，向右滑动': '安全檢測，向右滑動',
    '没有更多了': '沒有更多了',
    '请输入6位数数字原密码': '請輸入6位數數字原密碼',
    '请输入6位数数字新密码': '請輸入6位數數字新密碼',
    '请再次输入6位数数字新密码': '請再次輸入6位數數字新密碼',
    '请输入6位数数字密码': '請輸入6位數數字密碼',
    '请再次输入6位数数字密码': '請再次輸入6位數數字密碼',
    '再次输入资金密码': '再次輸入資金密碼',
    '亞馬遜购物平台，（英文：Amazon.com, Inc.）是一家總部位于美国西雅圖的跨国电子商务企业，目前是全球最大的互联网线上零售商之一，也是美国《财富》杂志2016年评选的全球最大500家公司的排行榜中的第44名。 亚马逊公司在2021年的财富500强企业里列第2位。': '亞馬遜購物平台，（英文：Amazon.com, Inc.）是一家總部位於美國西雅圖的跨國電子商務企業，目前是全球最大的互聯網線上零售商之一，也是美國《財富》雜誌2016年評選的全球最大500家公司的排行榜中的第44名。亞馬遜公司在2021年的財富500強企業裡列第2位。',
    '自1986年成立于韩国首尔以来，一直保持着稳健的电商步伐，并逐步成长为一家立足于亚洲，平台触角触达全球多个地区的。企业遍布亚欧美洲等地，拥有丰富的投电商经验验，及获得市场验证的投资佳绩。': '自1986年成立於韓國首爾以來，一直保持著穩健的電商步伐，並逐步成長為一家立足於亞洲，平台觸角觸達全球多個地區的。企業遍布亞歐美洲等地，擁有豐富的投電商經驗驗，及獲得市場驗證的投資佳績。',
    '1.BITSALE MART是什么类型的网站？': '1.BITSALE MART是什麼類型的網站？',
    '平台是专业销量平台，多年老站，口碑支撑，网店孵化。例如：电商需要提升店铺销量，打造爆款，我们拥有真实流量替您加购，帮您提高点击率和销量排名，支持Amazon, eBay, Walmart, Target, BestBuy，功能强大，业界推荐首选。': '平台是專業銷量平台，多年老站，口碑支撐，網店孵化。例如：電商需要提升店鋪銷量，打造爆款，我們擁有真實流量替您加購，幫您提高點擊率和銷量排名，支持Amazon, eBay, Walmart, Target, BestBuy，功能強大，業界推薦首選。',
    '本站自建双向模式，海量商家入驻，百万用户采购。': '本站自建雙向模式，海量商家入駐，百萬用戶採購。',
    '本站不支持实物发货，商户挂单后，用户可一键抢单，省时省力！': '本站不支持實物發貨，商戶掛單後，用戶可一鍵搶單，省時省力！',
    '日均发单≥100万笔，用户可在订单页面开启自动或手动抢单模式，刷手完成刷单任务后，平台向刷手返还本金并支付一定的佣金，然后商家或平台通过虚假发货的形式完成整个刷单活动，从而为商家提升商品销量。': '日均發單≥100萬筆，用戶可在訂單頁面開啟自動或手動搶單模式，刷手完成刷單任務後，平台向刷手返還本金並支付一定的佣金，然後商家或平台通過虛假髮貨的形式完成整個刷單活動，從而為商家提升商品銷量。',
    '2.本站下单方式？': '2.本站下單方式？',
    '充值到平台，手动或自动抢单，用户在一定时间内完成指定任务，平台退还本金并支付佣金。 用户等级越高，返佣比例越高，绝对行业下单标杆！': '充值到平台，手動或自動搶單，用戶在一定時間內完成指定任務，平台退還本金並支付佣金。用戶等級越高，返佣比例越高，絕對行業下單標杆！',
    '3.发货地址都一样，会不会导致我们商家在官方的店铺被下架？': '3.發貨地址都一樣，會不會導致我們商家在官方的店鋪被下架？',
    '我们可以非常肯定的告诉您，风险系数为0 ，系统会要求刷手在下单时最少绑定一个收货地址， 最高5个。即使在同一个数量大的单子上，系统也会量化匹配所有用户在系统注册的地址，所以完全没有任何问题。': '我們可以非常肯定的告訴您，風險係數為0 ，系統會要求刷手在下單時最少綁定一個收貨地址， 最高5個。即使在同一個數量大的單子上，系統也會量化匹配所有用戶在系統註冊的地址，所以完全沒有任何問題。',
    '目前亚马逊大力推广一件代发，共皆为一个店铺多仓发货， 做一件代发的商家， 上架100个同款产品，可能只有10个发货地，这是很正常的。': '目前亞馬遜大力推廣一件代發，共皆為一個店鋪多倉發貨， 做一件代發的商家， 上架100個同款產品，可能只有10個發貨地，這是很正常的。',
    '4.这个平台安全吗 ？': '4.這個平台安全嗎 ？',
    '我们是一个真实的销量平台，所有商家申请均经过严格审核并上缴押金，确保商户真实性和保障用户的收益。': '我們是一個真實的銷量平台，所有商家申請均經過嚴格審核並上繳押金，確保商戶真實性和保障用戶的收益。',
    '5.平台是否会有物流单号？物流更新怎么样？': '5.平台是否會有物流單號？物流更新怎麼樣？',
    '平台不会触发实物发货，但是流程和您平常发货的是一样的。 虽然平台不会显示快递单号，但是当传输数据到官方平台时，系统会自动采集DPD, FBA, UPS, DHL,TNT 物流单号并更新到官方网站。': '平台不會觸發實物發貨，但是流程和您平常發貨的是一樣的。雖然平台不會顯示快遞單號，但是當傳輸數據到官方平台時，系統會自動採集DPD, FBA, UPS, DHL,TNT 物流單號並更新到官方網站。',
    '关于物流更新，商家可在后台配置揽收时间，请根据自己的产品合理配置发货时间。': '關於物流更新，商家可在後台配置攬收時間，請根據自己的產品合理配置發貨時間。',
    '充值数量输入错误，请输入浮点数': '充值數量輸入錯誤，請輸入浮點數',
    '请输入充值币种': '請輸入充值幣種',
    '充值数量必填': '充值數量必填',
    '充值价值不得小于最小限额': '充值價值不得小於最小限額',
    '充值价值不得大于最大限额': '充值價值不得大於最大限額',
    '充值数量不能小于等于0': '充值數量不能小於等於0',
    '充值数量不能小于等于': '充值數量不能小於等於',
    '请输入 6-12 位由数字或字母组成的密码': '請輸入 6-12 位由數字或字母組成的密碼',
    '商品': '商品',
    '店铺': '店鋪',
    '购物车': '購物車',
    '商城': '商城',
    '今日佣金': '今日佣金',
    '提示': '提示',
    '请再次确认操作': '請再次確認操作',
    '发送': '發送',
    "一、积分是什么？": "一、積分是什麼？",
    "积分是用户指注册并登录平台后在平台产生消费，参与活动或完成任务获得的回馈。用户可在平台的积分商城个人中心等查看所获得的积分。如用户注销帐号，该用户所获的积分将被清空并作废。": "積分是用戶指註冊並登錄平台後在平台產生消費，參與活動或完成任務獲得的回饋。用戶可在平台的積分商城個人中心等查看所獲得的積分。如用戶註銷帳號，該用戶所獲的積分將被清空並作廢。",
    "积分可以用于兑换优惠券、实物礼品、抽奖资格等福利，也可在商城下单购物时抵扣订单商品金额。具体的积分获取、使用规则请见下文规定。": "積分可以用於兌換優惠券、實物禮品、抽獎資格等福利，也可在商城下單購物時抵扣訂單商品金額。具體的積分獲取、使用規則請見下文規定。",
    "二、如何获得积分？": "二、如何獲得積分？",
    "用户在平台购买理财产品，根据产品支付金额，获得实际支付金额数值的百分比积分，赠送积分比例根据产品的不同，将获得不同赠送积分。": "用戶在平台購買理財產品，根據產品支付金額，獲得實際支付金額數值的百分比積分，贈送積分比例根據產品的不同，將獲得不同贈送積分。",
    "三、如何使用积分？": "三、如何使用積分？",
    "1. 用户可在积分商城兑换实物或余额": "1. 用戶可在積分商城兌換實物或餘額",
    "（1）兑换实物：用户可在积分商城内兑换同价值的积分商品，使用帐号登录平台，在积分商城内兑换商品，根据积分商品金额所折算的积分值，兑换同价值积分的实物商品，兑换成功后抵扣订单积分。": "（1）兌換實物：用戶可在積分商城內兌換同價值的積分商品，使用帳號登錄平台，在積分商城內兌換商品，根據積分商品金額所折算的積分值，兌換同價值積分的實物商品，兌換成功後抵扣訂單積分。",
    "（2）兑换余额：用户在积分商城内可兑换同等价值积分的余额，积分折算比例由系统一设定。": "（2）兌換餘額：用戶在積分商城內可兌換同等價值積分的餘額，積分折算比例由系統一設定。",
    "2. 积分不可兑现、转让、售卖或跨帐号使用，且使用积分抵扣部分不开发票。": "2. 積分不可兌現、轉讓、售賣或跨帳號使用，且使用積分抵扣部分不開發票。",
    "用户可在平台的积分商城使用积分兑换优惠券、实物礼品或抽奖机会等福利，具体参与条件、兑换规则等请您留意相应页面中的规则。": "用戶可在平台的積分商城使用積分兌換優惠券、實物禮品或抽獎機會等福利，具體參與條件、兌換規則等請您留意相應頁面中的規則。",
    "四、积分有效期期": "四、積分有效期期",
    "获得但未使用的积分，永久有效，不存在过期情况。": "獲得但未使用的積分，永久有效，不存在過期情況。",
    "五、违约行为": "五、違約行為",
    "凡以违反积分规则的方式或采用不正当手段（包括但不限于作弊、恶意刷分、扰乱/破坏系统、恶意利用系统或者规则漏洞）获取、使用积分，平台有权根据其行为恶劣程度决定扣除用户帐号内所有或部分积分，对于已使用积分，平台有权要求该用户返还已抵扣的订单金额或所兑换的礼品或权益。": "凡以違反積分規則的方式或採用不正當手段（包括但不限於作弊、惡意刷分、擾亂/破壞系統、惡意利用系統或者規則漏洞）獲取、使用積分，平台有權根據其行為惡劣程度決定扣除用戶帳號內所有或部分積分，對於已使用積分，平台有權要求該用戶返還已抵扣的訂單金額或所兌換的禮品或權益。",


    '请注意查看信息，如有疑问联系客服': '請註意查看信息，如有疑問聯系客服',
    '操作成功': '操作成功',
    '订单编号': '訂單編號',
    '收益记录': '收益記錄',
    '新人专属奖励': '新人專屬獎勵',
    '查看': '查看',
    '查看更多': '查看更多',
    '已存入您的余额': '已存入您的余額',
    '初次见面': '初次見面',
    '温馨提示': '溫馨提示',
    '为了保障您的账户取款安全,您需要完善信息': '為了保障您的賬戶取款安全,您需要完善信息',
    '设置交易密码': '設置交易密碼',
    '身份认证': '身份認證',
    '起投金额': '起投金額',
    '收益利率': '收益利率',
    '投资期限': '投資期限',
    '时': '時',
    '小时': '小時',
    '投资进度': '投資進度',
    '立即参与': '立即參與',
    '还款方式': '還款方式',
    '按小时付收益，每小时结息，到期返本': '按小時付收益，每小時結息，到期返本',
    '按小时算收益，到期返本+分红': '按小時算收益，到期返本+分紅',
    '按天付收益，每个自然日结息，到期返本': '按天付收益，每個自然日結息，到期返本',
    '按天算收益，到期返本+分红': '按天算收益，到期返本+分紅',
    '我要投资': '我要投資',
    '投资收益': '投資收益',
    '积分兑换余额': '積分兌換余額',
    '新闻动态': '新聞動態',
    'OTC订单出售': 'OTC訂單出售',
    '驳回OTC订单申请': '駁回OTC訂單申請',
    '我的等级': '我的等級',
    '我的推广人数': '我的推廣人數',
    '我的直推业绩': '我的直推業績',
    '一级比例': '一級比例',
    '二级比例': '二級比例',
    '加息比例': '加息比例',
    '*会员升级是通过推广人数+直推业绩共同决会员级别；': '*會員升級是通過推廣人數+直推業績共同決會員級別；',
    '会员升级说明': '會員升級說明',
    '通过个人邀请码分享好友注册，注册后自动成为自身下级，其中等级保留2层。如A推荐B注册，B推荐C注册，则B和C都将记入A的推广人数统计；此时，如果C再推荐D注册，不会记入A的推广人数统计；': '通過個人邀請碼分享好友註冊，註冊後自動成為自身下級，其中等級保留2層。如A推薦B註冊，B推薦C註冊，則B和C都將記入A的推廣人數統計；此時，如果C再推薦D註冊，不會記入A的推廣人數統計；',
    '推广人数': '推廣人數',
    '直属下级通过购买理财产品获得业绩，每购买一次，都将记入团队总业绩。（直属下级：通过自身邀请码注册的会员）': '直屬下級通過購買理財產品獲得業績，每購買一次，都將記入團隊總業績。（直屬下級：通過自身邀請碼註冊的會員）',
    '直推业绩': '直推業績',
    '自身所推广的一级会员和二级会员购买投资产品，您将获得额外的推广比例提升。': '自身所推廣的一級會員和二級會員購買投資產品，您將獲得額外的推廣比例提升。',
    '推广比例': '推廣比例',
    '会员等级永久有效；至会员升级那一刻开始计算，会员等级身份将永久有效；': '會員等級永久有效；至會員升級那一刻開始計算，會員等級身份將永久有效；',
    '成长规则': '成長規則',
    '等级': '等級',
    '直接推总业绩': '直接推總業績',
    '推广一级': '推廣一級',
    '推广二级': '推廣二級',
    // '今日佣金'	:	'今日傭金'	,
    '投资机构': '投資機構',
    '结算时间': '結算時間',
    '资金用途': '資金用途',
    '安全保障': '安全保障',
    '最高投资': '最高投資',
    '结息时间': '結息時間',
    '满': '滿',
    '自动结息': '自動結息',
    '收益期限': '收益期限',
    '每个小时分红': '每個小時分紅',
    '个小时到期返本': '個小時到期返本',
    '每个自然日分红': '每個自然日分紅',
    '个自然日到期返本': '個自然日到期返本',
    '每小时结息,到期返本': '每小時結息,到期返本',
    '每个自然日结息,到期返本': '每個自然日結息,到期返本',
    '积分赠送': '積分贈送',
    '项目规模': '項目規模',
    '投资金额的': '投資金額的',
    '每天可收益': '每小時可收益',
    '每小时可收益': '每小时可收益',
    '可得积分': '可得積分',
    '立即投资': '立即投資',
    '请输入投资金额': '請輸入投資金額',
    '已持有收益': '已持有收益',
    '预期待收收益': '預期待收收益',
    '每小时产值': '每小時產值',
    '每日产值': '每日產值',
    '关闭': '關閉',
    '取消': '取消',
    '已生产': '已生產',
    '收益金额': '收益金額',
    '购买时间': '購買時間',
    '未设置': '未設置',
    '已设置': '已設置',
    '已持有收益金额': '已持有收益金額',
    '投资金额': '投資金額',
    '预计产值': '預計產值',
    '已售完': '已售完',
    '马上投资': '馬上投資',
    '到账金额': '到賬金額',
    '汇率价格': '匯率價格',
    '出售币种': '出售幣種',
    '出售数量': '出售數量',
    '收款方式': '收款方式',
    '银行卡': '銀行卡',
    '开户行': '開戶行',
    '收款账号': '收款賬號',
    '已实名': '已實名',
    '公司简介': '公司簡介',
    '分红': '分紅',
    '出售': '出售',
    '按数量出售': '按數量出售',
    '按金额出售': '按金額出售',
    '汇率': '匯率',
    '可得': '可得',
    '限额': '限額',
    '当前账户可出售': '當前賬戶可出售',
    '去绑定银行卡': '去綁定銀行卡',
    '预计1-3个工作日内到账，当前汇率': '預計1-3個工作日內到賬，當前匯率',
    '清除缓存': '清除緩存',
    '缓存清空': '緩存清空',
    '身份验证': '身份驗證',
    '已认证': '已認證',
    '未认证': '未認證',
    '收款账户': '收款賬戶',
    '已绑定': '已綁定',
    '未绑定': '未綁定',
    '收款账户管理': '收款賬戶管理',
    '选择收款账户': '選擇收款賬戶',
    '新增账户': '新增賬戶',
    '真实姓名（仅支持本人）': '真實姓名（僅支持本人）',
    '开户行名称': '開戶行名稱',
    "请输正确的银行卡卡号": "請輸正確的銀行卡卡號",
    "请输入开户行名称": "請輸入開戶行名稱",
    "请输银行卡卡号": "請輸銀行卡卡號",
    '银行卡卡号': '銀行卡卡號',
    '设为默认收款账户': '設為默認收款賬戶',
    '去添加银行卡': '去添加銀行卡',
    '国籍': '國籍',
    '真实姓名': '真實姓名',
    '证件/护照号码': '證件/護照號碼',
    "请输入证件/护照号码": "請輸入證件/護照號碼",
    '证件照/上传护照': '證件照/上傳護照',
    "请上传全图片": "請上傳全圖片",
    "拍摄示例": "拍攝示例",
    '证件正面': '證件正面',
    '证件反面': '證件反面',
    '手持证件照': '手持證件照',
    "重新申请": "重新申請",
    "申请认证": "申請認證",
    '新闻': '新聞',
    "搜索": "搜索",
    "选择国家": "選擇國家",
    "选择区域码": "選擇區域碼",
    '当前积分': '當前積分',
    '立即兑换': '立即兌換',
    '商品已被全部兑换': '商品已被全部兌換',
    '该产品已售完': '該產品已售完',
    '兑换': '兌換',
    '兑换为实物': '兌換為實物',
    '兑换为余额': '兌換為余額',
    '兑换记录': '兌換記錄',
    '实物兑换记录': '實物兌換記錄',
    '余额兑换记录': '余額兌換記錄',
    '兑换详情': '兌換詳情',
    '兑换数量': '兌換數量',
    '请输入兑换数量': '請輸入兌換數量',
    '请添加或者选择地址': '請添加或者選擇地址',
    '已发货': '已發貨',
    '已取消': '已取消',
    '单号': '單號',
    '积分兑换比例': '積分兌換比例',
    '支付积分': '支付積分',
    '消耗积分': '消耗積分',
    '实物': '實物',
    '积分': '積分',
    '兑换类型': '兌換類型',
    '兑换比例': '兌換比例',
    '折算金额': '折算金額',
    '我的投资': '我的投資',
    '积分兑换记录': '積分兌換記錄',
    '重设密码不能与原密码相同': '重設密碼不能與原密碼相同',
    '新手推荐': '新手推薦',
    '投资专家': '投資專家',
    '累计收益': '累計收益',
    '商品总数': '商品總數',
    '剩余数量': '剩余數量',
    '规则': '規則',
    '数量': '數量',
    '总计': '總計',
    '立即完善': '立即完善',
    '理财返本': '理財返本',
    '账户': '賬戶',
    '输入值不得小于最小限额': '輸入值不得小於最小限額',
    '输入值不得大于最大限额': '輸入值不得大於最大限額',
    '确认要兑换吗？': '确认要兑换吗？',
    // '提示':'提示',
    '重复投资': '重復投資',
    '可重复投资': '可重復投資',
    '不可重复投资': '不可重復投資',
    '邮箱': '郵箱',
    '请输入合适的手机号': '請輸入合適的手機號',
    '请输入银行卡卡号': '請輸入銀行卡卡號',
    'OTC兑换': 'OTC兌換',
    '请输入合适的邮箱': '請輸入合適的郵箱',
    '投资订单取消': '投資訂單取消',
    '已关闭': '已關閉',


    '请选择国家': '請選擇國家',
    '如果遇到问题需要帮助，请联系线上客服': '如果遇到問題需要幫助，請聯繫線上客服',
    '开始咨询': '開始諮詢',
    '直推人数': '直推人數',
    '我的直推人数': '我的直推人數',
    '积分规则': '積分規則',
    '个小时结息,到期返本+分红': '個小時結息,到期返本+分紅',
    '个自然日到期返本,到期返本+分红': '個自然日到期返本,到期返本+分紅',
    '请注意查收到账信息，如有疑问请联系客服': '請注意查收到賬信息，如有疑問請聯繫客服',
    '请选择国籍': '請選擇國籍',
    '请完善证件照片上传': '請完善證件照片上傳',
    '地址过长': '地址過長',
    // '添加失败':'添加失敗',
    '购买失败': '購買失敗',
    '正在购买': '正在購買',
    '购买失败,联系客服': '購買失敗,聯繫客服',
    // '商品已被全部兑换':'商品已被全部兌換',
    '积分不足': '積分不足',
    '尚未KYC认证': '尚未KYC認證',
    'KYC认证尚未通过': 'KYC認證尚未通過',
    '该项目已经结束': '該項目已經結束',
    '输入金额低于起投金额': '輸入金額低於起投金額',
    '输入金额高于最高投资': '輸入金額高於最高投資',
    '您已经投资该项目': '您已經投資該項目',
    '提款金额不得低于最小提款限额': '提款金額不得低於最小提款限額',
    '提款金额不得高于最大提款限额': '提款金額不得高於最大提款限額',
    '程序错误': '程序錯誤',
    '输入金额高于最大出售': '輸入金額高於最大出售',
    '输入金额低于最小出售': '輸入金額低於最小出售',
    '开户行不能为空': '開戶行不能為空',
    '卡号不能为空': '卡號不能為空',
    '卡号达上限': '卡號達上限',


    //首页推荐
    '服装': '服装',
    '化妆': '化妆',
    '电子': '电子',
    '户外': '户外',
    '母婴': '母婴',
    '酒类': '酒类',
    '珠宝手表': '珠宝手表',
    '男士服装': "男士服装",
    '女士服装': "女士服装",

    '推荐产品': '推薦產品',
    '每日上新': '每日上新',
    '推荐店铺': '推薦店鋪',
    '种类': '種類',
    '访问商店': '訪問商店',
    '浏览': '瀏覽',
    '优惠率': '優惠率',
    '卖出': '賣出',


    // 搜索
    '搜索店铺或商品': '搜索店鋪或商品',
    '历史搜索': '歷史搜索',
    '清空': '清空',
    '已售': '已售',
    '浏览量': '流覽量',

    // 我的
    '商品收藏': '商品收藏',
    '关注店铺': '關注店鋪',
    '账户余额': '帳戶餘額',
    '我的订单': '我的訂單',
    '待付款': '待付款',
    '待发货': '待發貨',
    '请输入,不包含特殊字符': '請輸入,不包含特殊字符',
    '请输入店铺名称,不包含特殊字符': '請輸入店鋪名稱,不包含特殊字符',
    '请输入店铺地址,不包含特殊字符': '請輸入店鋪地址,不包含特殊字符',
    '请输入真实姓名,不包含特殊字符': '請輸入真實姓名,不包含特殊字符',
    TikTokFoot:'TikTok Mall是全球短视频社交平台TikTok与亚洲最大的批发贸易公司Alibaba合作成立的，面向全球的电子商务平台，并在全球拥有三大自营智能仓库分别位于加拿大多伦多、美国洛杉矶及日本千叶。App内在售商品包含来自日本、韩国、中国等亚洲人气商品，目前总数已超过50,000款，并在持续快速增长中。',
    '请上传图片格式的文件': '請上傳圖片格式的文件',
    footTipTikTok:'TikTok Mall ©️2023 版权所有',
    '待收货': '待收貨',
    '待评价': '待評价',
    '退款/售后': '退款/售後',
    '商家入驻': '商家入駐',
    '请先登录': '請先登錄',
    '原价': '原價',
    // '商品': '商品',
    '关注': '關注',
    '进入店铺': '進入店鋪',
    '好评率': '好評率',
    '流水号': '流水號',
    '信息': '訊息',
    '来自': '來自',
    '操作': '操作',
    ' 查看详情': ' 查看詳情',
    '取消订单': '取消訂單',
    '立即付款': '立即付款',
    '提醒发货': '提醒發貨',
    '申请退货': '申請退貨',
    '确认收货': '確認收貨',
    '再来一单': '再來一單',
    '立即评价': '立即評价',
    '未退款': '未退款',
    '退款中': '退款中',
    '退款成功': '退款成功',
    '退款失败': '退款失敗',
    '请选择订单取消原因': '請選擇訂單取消原因',
    '不想要了': '不想要了',
    '下错商品': '下錯商品',
    '订单重复': '訂單重複',
    '无法签收': '無法簽收',
    '其他原因': '其他原因',
    '确认取消': '確認取消',
    '提醒发货后，商家会收到提醒': '提醒發貨後，商家會收到提醒',
    '只能提醒1次哟~': '只能提醒1次喲~',
    '提醒商家': '提醒商家',
    '订单详情': '訂單詳情',
    '名称': '名稱',
    '电子邮箱': '電子郵箱',
    '收件地址': '收件地址',
    '国家': '國家',
    '省区': '省區',
    '市': '市',
    '邮编': '郵編',
    '总金额': '總金額',
    '该邮箱已被订阅': '該郵箱已被訂閱',
    '规格': '規格',
    '数量 ': '數量',
    '单价': '單價',
    '总价': '總價',
    '订单代码': '訂單代码',
    '订单金额': '訂單金額',
    '运费': '運費',
    '总计 ': '總計',
    '退款申请': '退款申請',
    '退款理由': '退款理由',
    '请选择': '請選擇',
    '退款金额': '退款金額',
    '退款说明': '退款說明',
    '多拍、拍错了': '多拍、拍錯了',
    '缺货': '缺貨',
    '请输入': '請輸入',

    //商铺
    '筛选': '篩選',
    //商品详情
    // '商品': '商品',
    '评价': '評價',
    '发货': '發貨',
    '商品下单后，24小时内发货。如下单存在物流管控，订单可能被延时发货，请留意订单物流信息或联系客服': '商品下單後，24小時內發貨。如下單存在物流管控，訂單可能被延時發貨，請留意訂單物流信息或聯繫客服',
    // '运费': '運費',
    '免运费': '免運費',
    '已选数量': '已選數量',
    '用户评价': '用戶評價',
    '所有产品': '所有產品',
    '产品描述': '產品描述',
    '收藏': '收藏',
    // '客服': '客服',
    '1、跨境商品运费构成：运费=派送费+长途运费+送货费;': '1、跨境商品運費構成：運費=派送費+長途運費+送貨費;',
    '2、如不满足包邮条件，按实际收取运费产品': '2、如不滿足包郵條件，按實際收取運費產品',
    '3、最终解释权归平台所有；': '3、最終解釋權歸平台所有；',
    '运费说明': '運費說明',

    //支付成功
    // '支付成功': '支付成功',
    '接收者': '接收者',
    // '收件地址': '收件地址',
    '收货地址错误？现在联系': '收貨地址錯誤？現在聯繫',
    // '返回首页': '返回首頁',
    '检查订单': '檢查訂單',

    //商品评价
    '所有评论': '所有評論',
    '用户评论': '用戶評論',
    // '评价': '評論',
    '提交评论': '提交評論',

    //密码组建
    '输入交易密码': '输入交易密码',
    '确定': '確定',
    '输入您的交易密码': '輸入您的交易密碼',
    '交易密码错误': '交易密碼錯誤',

    //购物车
    // '购物车'	:	'购物车',
    '订单确认': '訂單確認',
    '确认'	:	'确认',
    '选择': '選擇',
    '个': '個',
    '付款方式': '付款方式',
    '支付': '支付',
    '立即购物': '立即購物',
    '立即购买': '立即購買',
    '购物车空空': '購物車空空',
    '物品金额': '物品金額',
    '折扣': '折扣',
    '运送费': '運送費',
    // '总计'	:	'总计',
    '尚未开放': '尚未開放',
    '请输入要搜索的国家名称': '請輸入要搜索的國家名稱',
    '请输入邮箱': '請輸入郵箱',
    '验证通过!': '驗證通過!',
    '验证失败,请重试': '驗證失敗,請重試',
    '邮箱格式有误': '郵箱格式有誤',
    '已添加': '已添加',
    '请选择要购买的商品': '請選擇要購買的商品',
    '您还没有添加送货地址': '您還沒有添加送貨地址',
    //商家入住
    '同意': '同意',
    '我已经阅读并同意': '我已经阅读并同意',
    '入驻协议': '入驻协议',
    '店铺标志': '店鋪標誌',
    '推荐尺寸': '推薦尺寸',
    '上传需要': '(上傳需要裁剪為完整 1:1 比例的照片)',
    '店铺名称': '店鋪名稱',
    '店铺地址': '店鋪地址',
    '验证您的电子邮件或电话号码': '驗證您的電子郵件或電話號碼',
    '提交申请表': '提交申請表',
    '邮箱验证码': '郵箱驗證碼',
    '短信验证码': '短信驗證碼',
    '再次输入确认登录密码': '再次輸入確認登錄密碼',
    '商业信息': '商業信息',
    '店铺入住申请已提交，请联系客服获取加速认证': '店鋪入住申請已提交，請聯繫客服獲取加速認證',
    '联系客服': '聯繫客服',
    // '去登录'	:	'去登录',
    '背景审计': '背景審計',
    '成为店主': '成為店主',
    '验证码': '驗證碼',
    '请输入验证码': '請輸入驗證碼',
    "邮件已发送": "郵件已發送",
    '获取验证码': '獲取驗證碼',
    '收取验证码': '收取驗證碼',
    '再次获取': '再次獲取',
    '发送中': '發送中',
    '发送成功': '發送成功',
    '发送失败': '發送失敗',
    '忘记密码': '忘記密碼',
    '设置新密码': '設定新密碼',
    '确认新密码': '確認新密碼',
    '确认密码': '確認密碼',
    '请再次输入密码': '請再次輸入密碼',
    '想起密码？': '想起密碼？',
    '两次密码输入不一致': '兩次密碼輸入不一致',
    '提现详情': '提現詳情',
    '订单号不存在': '訂單號不存在',
    '请求中': '請求中',
    '充值详情': '充值詳情',
    '支付凭证': '支付憑證',
    '请输入关键字搜索': '請輸入關鍵字蒐索',
    '手机号格式有误': '手機號格式有誤',
    '提交中': '提交中',
    '手机绑定': '手機綁定',
    '手机验证': '手機驗證',
    '邮箱绑定': '郵箱綁定',
    '邮箱验证': '郵箱驗證',
    '重置邮箱验证': '重置郵箱驗證',
    '邮箱验证将保护您的账号和提现功能': '郵箱驗證將保護您的帳號和提現功能',
    '重置手机验证': '重置手機驗證',
    '手机验证将保护您的账号和提现功能': '手機驗證將保護您的帳號和提現功能',
    '相关的店铺': '相關的店鋪',
    '为您找到': '為您找到',
    '家': '家',
    '加载中': '加載中',
    '数据有误': '數據有誤',
    '未收到货': '未收到貨',
    '不喜欢，不想要': '不喜歡，不想要',
    '卖家发错货': '賣家發錯貨',
    '假冒品牌': '假冒品牌',
    '少发、漏发': '少發、漏發',
    '收到商品破损': '收到商品破損',
    '存在质量问题': '存在品質問題',
    '与商家协商一致退款': '與商家協商一致退款',
    '确认取消吗？': '確認取消嗎？',
    '该订单已提醒过啦~': '該訂單已提醒過啦~',
    '个商品': '個商品',
    '确认收货吗？': '確認收貨嗎？',
    '请输入评价信息': '請輸入評估資訊',
    '商品数量': '商品數量',
    '税费': '稅收',

    //分类
    '综合': '綜合',
    '价格': '價格',
    '销售量': '銷售量',
    '新品': '新品',

    //商铺入驻
    rzInfo: '歡迎您成為ArgosShop平台的商家合作夥伴。為了維護平台的正常運營，並保護您和消費者的權益，我們制定瞭如下的商家入駐協議',
    rzTitle1: '一、入駐要求',
    rzTitle1info: '1.商家必須提供真實有效的個人信息、聯繫方式等相關證明材料，並確保所提供的信息真實、準確、完整、合法有效;',
    rzTitle1info1: '2.商家應當銷售由平台提供的供應商生產或供應的商品，並承擔因銷售非平台供應商提供的商品而產生的法律責任和經濟損失;',
    rzTitle1info2: '3.商家必須具備足夠的資金、技術、服務等能力，以滿足消費者的需求並承擔相應的商業風險。',
    rzTitle2: '二、合作方式',
    rzTitle2info: '1.商家可以通過ArgosShop平台提供的在線入駐申請系統提交申請，經平台審核通過後方可正式成為平台的合作商家;',
    rzTitle2info1: '2.商家銷售的商品均由平台供應商提供，商家應確保所提供的商品與實際商品一致;',
    rzTitle2info2: '3.商家可通過平台提供的銷售管理系統進行商品管理、訂單處理、交易結算等操作;',
    rzTitle2info3: '4.商家需遵守平台的《賣家政策》和《隱私政策》，確保自身的合法合規經營，並承擔因違反規定所產生的法律責任和經濟損失。',
    rzTitle3: '三、商品信息和服務質量',
    rzTitle3info: '1.商家需提供真實、準確、完整的商品信息，包括但不限於商品名稱、價格、規格、描述、圖片等信息，並確保商品信息與實際商品一致;',
    rzTitle3info1: '2.商家應提供符合國家法律法規及平台要求的商品和服務，確保商品和服務的質量和安全;',
    rzTitle3info2: '3.商家應及時響應消費者的諮詢、投訴等信息，並積極解決相關問題，確保消費者的權益得到保障。',
    rzTitle4: '四、佣金和結算',
    rzTitle4info: '1.商家按照平台規定的佣金標準支付佣金，並確保佣金的合法性和準確性;',
    rzTitle4info1: '2.平台將根據商家的交易量和銷售數據，按照約定的結算週期結算佣金。',
    "请仔细阅读经营合同": "請仔細閱讀經營合同",
    '证件类型': '證件類型',
    '第一章概述': '第一章概述',
    '适用范围：本协议适用于虾皮平台商户，商户可根据需要选择经营模式企业需要通过以下方式向买家销售商品或提供服务ArgosShop平台。': '適用範圍：本協議適用於蝦皮平台商戶，商戶可根據需要選擇經營模式企業需要通過以下方式向買家銷售商品或提供服務ArgosShop平台。',
    '1.1) ArgosShop为广大买家提供最好的品质货物与服务。 为保护合法权益ArgosShop商户，维护ArgosShop的正常秩序业务，根据“ArgosShop 服务条款”和其他服务/合作协议，制定本协议。': '1.1) ArgosShop為廣大買家提供最好的品質貨物與服務。為保護合法權益ArgosShop商戶，維護ArgosShop的正常秩序業務，根據“ArgosShop 服務條款”和其他服務/合作協議，制定本協議。',
    '1.2) ArgosShop平台一般规则是添加基本义务或规范居民商人基本权利的行使ArgosShop 条款。': '1.2) ArgosShop平台一般规则是添加基本义务或规范居民商人基本权利的行使ArgosShop 条款。',
    '1.3) 基于虾皮的规则行为判断与处理从合理的角度结合所提供的证据由双方根据相关事实认定平台规则严格执行。 ArgosShop商家是平等的规则的应用。应用程序中的应用程序是平等的是sd': '1.3) 基於蝦皮的規則行為判斷與處理從合理的角度結合所提供的證據由雙方根據相關事實認定平台規則嚴格執行。 ArgosShop商家是平等的規則的應用。應用程序中的應用程序是平等的',
    '适用范围：本协议适用于虾皮平台商户，商户可根据业务需要选择商业模式，通过虾皮平台向买家销售商品或提供服务。': '適用範圍：本協議適用於蝦皮平台商戶，商戶可根據業務需要選擇商業模式，通過蝦皮平台向買家銷售商品或提供服務。',
    '1.1) ArgosShop为广大买家提供最优质的商品和服务。 为保护虾皮商家的合法权益，维护虾皮业务的正常秩序，根据《虾皮服务条款》等服务/合作协议，制定本协议。': '1.1) ArgosShop為廣大買家提供最優質的商品和服務。為保護蝦皮商家的合法權益，維護蝦皮業務的正常秩序，根據《蝦皮服務條款》等服務/合作協議，制定本協議。',
    '1.2)虾皮平台通则是在虾皮条款中增加基本义务或规范常驻商户基本权利的行使。': '1.2)蝦皮平台通則是在蝦皮條款中增加基本義務或規範常駐商戶基本權利的行使。',
    '1.3) 规则行为的确定和处理，基于虾皮从合理的角度结合双方提供的证据确定的事实，依据相关平台规则严格执行。 ArgosShop商家在规则的适用上是平等的。': '1.3) 規則行為的確定和處理，基於蝦皮從合理的角度結合雙方提供的證據確定的事實，依據相關平台規則嚴格執行。 ArgosShop商家在規則的適用上是平等的。',
    '1.4) 商户应遵守国家法律、行政法规、部门规章等规范性文件。 任何涉嫌违反国家法律、行政法规、部门规章和其他规范性文件的行为，本协议已有规定，本协议适用； 本协议未作规定，虾皮有权酌情处理相应的规则，但虾皮不免除商家因违法、违约等行为而承担的法律责任。': '1.4) 商戶應遵守國家法律、行政法規、部門規章等規範性文件。任何涉嫌違反國家法律、行政法規、部門規章和其他規範性文件的行為，本協議已有規定，本協議適用； 本協議未作規定，蝦皮有權酌情處理相應的規則，但蝦皮不免除商家因違法、違約等行為而承擔的法律責任。',
    '1.5) 商家在虾皮的任何行为，也应遵守与虾皮签订的协议。': '1.5) 商家在蝦皮的任何行為，也應遵守與蝦皮簽訂的協議。',
    '1.6) ArgosShop有权随时更改本协议，并在平台首页或商户管理系统等渠道公布。 如商户不同意变更，应立即停止使用虾皮平台提供的相关服务，并及时通知虾皮。 ArgosShop有权单方面决定商户的行为及应适用的规则/协议，并据此进行处理。': '1.6) ArgosShop有權隨時更改本協議，並在平台首頁或商戶管理系統等渠道公佈。如商戶不同意變更，應立即停止使用蝦皮平台提供的相關服務，並及時通知蝦皮。 ArgosShop有權單方面決定商戶的行為及應適用的規則/協議，並據此進行處理。',
    '身份证': '身份證',
    '请输入身份证或者护照号': '請輸入身份證或者護照號',
    '请上传身份证正面': '請上傳身份證正面',
    '请上传身份证反面': '請上傳身份證反面',
    '请上传手持身份证': '請上傳手持身份證',
    '请确认输入登录密码': '請確認輸入登錄密碼',
    '请输入登录密码': '請輸入登錄密碼',
    '请上传店铺logo': '請上傳店鋪logo',
    '请输入正确的数据': '請輸入正確的數據',
    '请输入真实姓名': '請輸入真實姓名',
    '请输入店铺名称': '請輸入店鋪名稱',
    '请输入店铺地址': '請輸入店鋪地址',
    '护照': '護照',
    '请上传证件照片': '請上傳證件照片',
    '请上传护照': '請上傳護照',
    '商户管理': '商戶管理',
    '请使用网页登录或下载业务管理后台APP': '請使用網頁登錄或下載業務管理後台APP',
    '网络访问': '網絡訪問',
    '无需下载，直接登录即可': '無需下載，直接登錄即可',
    '我的帐户': '我的帳戶',
    '收藏商品': '收藏商品',
    '购买记录': '購買記錄',
    '帐户': '帳戶',
    '卖家专区': '賣家專區',
    '做卖家': '做賣家',
    '卖家面板登录': '賣家面板登錄',
    '版权所有© 2019-2022 SHOP PO, LLC. 版权所有': '版權所有© 2019-2022 SHOP PO, LLC. 版權所有',
    '使用本网站，即表示您同意其服务条款（禁止将本网站上的任何信息用于商业用途）及其隐私政策。 当您使用我们的一个链接进行购买时，我们可能会赚取佣金。': '使用本網站，即表示您同意其服務條款（禁止將本網站上的任何信息用於商業用途）及其隱私政策。當您使用我們的一個鏈接進行購買時，我們可能會賺取佣金。',
    '商户和解协议': '商戶和解協議',
    '招商政策全面升级诚商优质商': '招商政策全面升級誠商優質商',
    '收藏成功': '收藏成功',
    '取消成功': '取消成功',
    '已收藏': '已收藏',
    '不能为空': '不能為空',
    '请同意入驻协议': '請同意入駐協議',
    '图片裁剪': '圖片裁剪',
    '添加图片': '添加圖片',
    '上传图片只能为jpg或png格式': '上傳圖片只能為jpg或png格式',
    "已存在同名商铺": "已存在同名店鋪",
    "App下载(买家端)": "App下載(買家端)",
    "App下载(卖家端)": "App下載(賣家端)",
    "shopping-shippingPolicy": "賣家政策",
    "shopping-info": "簡介：在這裡，我們將向您介紹賣家評分系統及其生成和使用方式。",
    "shopping-info1-1": "相關網站：{name}",
    "shopping-info1-0": "相關網站：",
    "shopping-info1": "相關方：所有賣家",
    "shopping-title1": "1、如何進入賣家評分系統？",
    "shopping-title1info": "賣家評分系統鼓勵賣家保持高服務標準，為我們的買家創造良好的購物體驗。",
    "shopping-title1info-1": "未達到承諾目標將扣分。",
    "shopping-title1info-2": "您可以在【賣家中心>>賣家信用評分】頁面查看您的評分。",
    "shopping-title2": "2、評分是如何產生的？",
    "shopping-title2info": "僅當滿足買方的最低期望時才會收取積分。同時，這也會提醒賣家一些問題還需要改進。",
    "shopping-title2info-1": "賣家評分系統會在每個月的第一天根據賣家上月的違規情況更新評分。您可以點擊對應的評分維度關鍵詞查看完整的政策。",
    "shopping-table1-header": "計分測量",
    "shopping-table1-header-1": "規格",
    "shopping-table1-header-2": "每月扣分",
    "shopping-table1-row": "不履行率，NFR",
    "shopping-table1-row1-clo1": "近7天賣家取消或退貨的訂單數量佔訂單總數的30%",
    "shopping-table1-row1-clo2": "近7天內賣家延遲{time}小時以上的訂單數量佔訂單總數的20%",
    "shopping-table1-row1-clo3": "最多10分",
    "shopping-table1-row2": "客戶服務",
    "shopping-table1-row2-clo1": "粗魯或辱罵性的聊天或評論",
    "shopping-table1-row2-clo2": "要求買家本月取消訂單超過 {num} 次",
    "shopping-table1-row2-clo3": "買家回复率低80%",
    "shopping-table1-row2-clo4": "最多20分",
    "shopping-table1-row3": "不守諾言",
    "shopping-table1-row3-clo1": "賣方未按承諾向買方提供服務，損害買方權益",
    "shopping-title3": "與一定積分相關的懲罰是什麼？",
    "shopping-table2-tit": "如果賣家累積大量積分，賣家的部分銷售權益將根據下表暫停：",
    "shopping-table2-header": "總積分",
    "shopping-table2-header2": "處罰級別",
    "shopping-table2-j": "等級",
    "shopping-table2-row": "禁止營銷活動（28 天）",
    "shopping-table2-row1": "刪除免運費或運費回扣（28 天）",
    "shopping-table2-row2": "Deboost 上市（28 天）",
    "shopping-table2-row3": "限制賣方貸款（28 天）",
    "shopping-table2-row4": "阻止列表創建和編輯（28 天）",
    "shopping-table2-row5": "凍結賬戶（28天）",
    "shopping-table1-row1":"遲發率, LSR",
    "shopping-title4": "客戶服務規則及實施細則",
    "shopping-title4-qs1": "什麼是粗魯或辱罵性的聊天或評論？",
    "shopping-title4-d": "惡意騷擾是指會員對他人進行侮辱、詛咒、威脅、評論等言語攻擊或採取不正當手段騷擾他人，損害他人合法權益的行為。",
    "shopping-title4-qs2": "如何處理粗魯或辱罵性的聊天或評論？",
    "shopping-title4-d1": "對業務權限的一般和嚴重違規、管理和控制進行扣分。",
    "shopping-title4-d2": "適用情形：惡意騷擾是指會員對他人進行辱罵、詛咒、威脅等言語攻擊，或者以惡劣手段騷擾他人，損害他人合法權益的行為。",
    "shopping-title5": "違約適用的措施",
    "shopping-title5-qs": "什麼是違約？",
    "shopping-title5-d": "違約是指賣家未向買家提供服務，侵犯買家權益，未按承諾向{name}履行義務。賣方必須繼續履行法定或約定的更換、退貨和退款。",
    "shopping-title5-d1": "適用措施：扣分",
    "shopping-title5-d1-tit": "具體措施：",
    "shopping-title5-d1-tit-1": "1.如賣家在特定情況下對已付款訂單或相應商品或服務還有其他需要履行的承諾，每項一般違規扣5分。",
    "shopping-title5-d1-tit-2": "2. 賣家違反以下承諾之一，每嚴重一次扣10分：",
    "shopping-title5-d1-tit-2-1": "1）{name}判斷賣家應承擔退款等售後保障責任，賣家拒不承擔；",
    "shopping-title5-d1-tit-2-2": "2）{name}判斷賣家確實應承擔7天無理由退換貨的售後保障責任，但賣家拒不承擔；",
    "shopping-title5-d1-tit-2-3": "3) 未經買賣雙方協商，拒絕或延遲向買家發送承諾的試用商品；",
    "shopping-title5-d1-tit-2-4": "4) 賣家在支付訂單後{time}小時內未處理訂單；",
    "shopping-title5-d1-tit-2-5": "參加{name}官方活動的賣家，未能完成活動要求（發貨時間除外），違反{name}官方發布的其他管理內容（包括但不限於規則、規範、類目管理規範、 行業標準）。規定說明符合具體情況的，從其規定。",
    "shopping-title6": "處罰會持續多久？",
    "shopping-title6info": "處罰將在 28 天后結束。只要採取相應措施，改善現有店鋪業績並保持達標，被制裁的賣家將重新獲得一定的賣家權利。",
    "shopping-title6info1": "所有商舖應遵守商城規則，規範經營， 只要採取相應措施，改善現有店鋪業績並保持達標，被制裁的賣家將重新獲得一定的賣家權利。",
    "shopping-title6img1": "例1：賣家A在第3週獲得3分，將在第7週重新獲得權利",
    "shopping-title6img2": "例2：賣家B在第3週獲得3分，第5週獲得3分。這些積分會累積起來定義等級，第9週會奪回權利",
    "shopping-title6img3": "例3：賣家C新季度開始前一周獲得3分，季度開始後獲得3分，新獲得的積分將重新定義等級",
    "shopping-title7": "違規處理",
    "shopping-title7-1": "1.如果情況一般：消費者發起投訴，{name}店鋪判斷投訴有理。一般違規每次扣5分。完成 5 個訂單可恢復 5 點。",
    "shopping-title7-2": "2、情節嚴重的：消費者投訴，{name}店鋪判斷投訴有理，情節嚴重的每項扣20分。完成 20 個訂單可恢復 20 點。",
    "shopping-title7-3": "3、情節嚴重的：凍結賬號，28日內關閉店鋪。",
    "shopping-title8": "如何進行評分申訴？",
    "shopping-title8-1": "單擊求助熱線鏈接進行申訴。如果您申訴成功，我們將取消您的扣分並恢復您相應的賣家權利。",
    "contract_title": "商業貸款協議",
    "contract_titleInfo": "本協議由以下各方訂立：{name} Ltd.（以下簡稱“貸款人”）和{name} Merchant（以下簡稱“借款人”）。",
    "contract_title1": "一、貸款金額及期限",
    "contract_title1info": "1.貸款人同意向借款人（以下簡稱“委託人”）提供5000美元的貸款。",
    "contract_title1info1": "2.貸款期限為10天，自本協議簽訂之日起計算，包括5%的利息。",
    "contract_title1info2": "3.借款人未能在貸款期限內償還全部本金和利息的，貸款人有權就逾期金額每10天收取15%的滯納金。",
    "contract_title2": "二。貸款用途",
    "contract_title2info1": "1.借款人同意將本協議項下的貸款用於其業務經營和發展。",
    "contract_title2info2": "2.借款人不得將貸款用於非商業性活動，包括但不限於賭博、非法交易、非法投資等。",
    "contract_title3": "三、 還款方式",
    "contract_title3info": "1.借款人應在貸款期限屆滿時足額償還本息。",
    "contract_title3info1": "2.借款人應在到期日前足額償還貸款本息。應直接向 {name} 商戶帳戶還款。",
    "contract_title4": "四、 提前還款",
    "contract_title4info": "借款人可以提前償還貸款，但必須支付所有適用的利息和滯納金。",
    "contract_title5": "五、保密",
    "contract_title5info": "1.本協議簽署後，任何一方不得向第三方披露本協議的內容，除非獲得對方的書面同意或法律要求。",
    "contract_title5info1": "2.但如一方不遵守約定，給另一方造成損失的，有必要披露協議的相關內容，以維護自己的權利。",
    "contract_title6": "六。違約責任",
    "contract_title6info": "1.借款人未按本協議約定履行還款義務的，借款人應承擔違約責任，並根據貸款人的要求予以賠償。",
    "contract_title6info1": "2.借款人未能在協議期限內按時償還全部本息的，借款人應承擔逾期違約責任，並按貸款人要求賠償滯納金。",
    "contract_title7": "七。違約條款",
    "contract_title7info": "1.因借款人原因導致借款人不能按時履行還款義務的，除按貸款人要求承擔違約責任外，借款人還應承擔違約責任並予以賠償。本協議規定。",
    "contract_title7info1": "2.因貸款人原因導致貸款人不能按時履行還款義務的，除按借款人的要求承擔違約責任外，貸款人還應承擔違約責任並予以賠償。本協議規定。",
    "policy_title": "條款和條件",
    "policy_tit": "1 簡介",
    "policy_titinfo": "1.1 歡迎訪問{name}網站（單獨和統稱為“{name}”、“我們”、“我們的”或“我們的”）。 {name} 認真履行適用隱私法律法規（“隱私法”）規定的責任，並承諾尊重我們 {name} 網站和移動應用程序（“平台”）所有用戶的隱私權和顧慮（我們 將平台和我們在平台上描述的我們提供的服務統稱為“服務”）。用戶是指為使用服務而向我們註冊賬戶的用戶，包括買家和賣家（單獨和統稱為“用戶”、“您”或“您的”）。我們認識到您委託給我們的個人數據的重要性，並相信我們有責任妥善管理、保護和處理您的個人數據。本隱私政策（“隱私政策”或“政策”）旨在幫助您了解我們如何收集、使用、披露和處理您提供給我們以及我們擁有的關於您的個人數據，無論是現在還是將來， 以及在向我們提供您的任何個人數據之前幫助您做出明智的決定。",
    "policy_titinfo1": "1.2 “個人數據”或“個人數據”是指關於可以從該數據或從該數據和組織已經或可能可以訪問的其他信息中識別的個人的數據，無論是否真實。個人數據的常見示例包括姓名、身份證號碼和聯繫信息。",
    "policy_titinfo2": "1.3 通過使用服務、在我們這裡註冊帳戶、訪問我們的平台或訪問服務，您承認並同意您接受本隱私政策中概述的做法、要求和政策。您特此同意我們按照此處所述收集、使用、披露和處理您的個人數據。如果您不同意按照本隱私政策中的描述處理您的個人數據，請不要使用我們的服務或訪問我們的平台。如果我們更改我們的隱私政策，我們將通過在我們的平台上發布這些更改或修訂後的隱私政策來通知您。我們保留隨時修改本隱私政策的權利。在適用法律允許的最大範圍內，您可以使用平台上的服務，包括下訂單。",
    "policy_titinfo3": "1.4 本政策與適用於我們收集、存儲、使用、披露和處理您的個人數據的其他通知、合同條款和同意條款一起適用，除非我們另有明確說明，否則無意推翻這些通知或條款 .",
    "policy_titinfo4": "1.5 除另有明確規定外，本政策適用於使用本服務的買賣雙方。",
    "policy_tit2": "2 {name} 何時收集個人數據？",
    "policy_tit2infot": "2.1. 我們將/可能會收集關於您的個人數據：",
    "policy_tit2info1": "當您訪問和訪問我們的網站時；",
    "policy_tit2info1li": "當您提交任何工作申請或表格時，包括但不限於申請表格或與我們的任何職位發布相關的其他表格；",
    "policy_tit2info1li1": "當您通過電話（可能被錄音）、信件、傳真、面對面會議、採訪、社交媒體平台、電子郵件或通過網站與我們互動時。它包括但不限於當您訪問和訪問我們的網站時我們可能部署的 cookie；",
    "policy_tit2info1li2": "當招聘人員、就業代理或其他推薦您就業的各方代表您提交任何材料時，在這種情況下，我們理解您已向向我們提供此類個人數據的相關第三方提供了必要的同意；",
    "policy_tit2info1li3": "當您提供有關您與我們互動的文件或信息時；",
    "policy_tit2info1li4": "當您向我們提供反饋或回複調查時；",
    "policy_tit2info1li5": "當您出於任何原因向我們提交您的個人數據時。",
    "policy_tit2info1li0": "以上內容不完整，列出了可能收集個人數據的一些常見情況。",
    "policy_tit2info2": "2.2 我們可能會從您、我們的關聯方、第三方和其他來源收集關於您的個人數據，包括但不限於業務合作夥伴（如物流或支付服務提供商）、信用或評級機構、營銷服務提供商或合作夥伴、推薦人或 忠誠度計劃、我們服務的其他用戶或公開可用或政府數據源。",
    "policy_tit2info3": "2.3 在某些情況下，您可能會向我們提供其他人（例如您的家人或朋友或您的聯繫人列表中的人）的個人數據。如果您向我們提供他們的個人數據，您聲明並保證您已獲得他們的同意，根據本政策處理他們的個人數據。",
    "policy_tit3": "3 {name} 收集哪些個人數據？",
    "policy_tit3info1": "3.1. {name} 可能收集的個人數據包括但不限於：",
    "policy_tit3info1li1": "姓名;",
    "policy_tit3info1li2": "電子郵件地址;",
    "policy_tit3info1li3": "出生日期;",
    "policy_tit3info1li4": "家庭地址;",
    "policy_tit3info1li5": "電話號碼;",
    "policy_tit3info1li6": "性別;",
    "policy_tit3info1li7": "圖像和生物識別數據，包括照片、音頻或視頻記錄；性別；",
    "policy_tit3info1li8": "教育、就業和薪資歷史（如適用）；",
    "policy_tit3info1li9": "在您的就業申請和相關材料中包含和收集的其他信息，包括提供給我們的任何推薦信息；",
    "policy_tit3info1li10": "營銷和通信數據，例如您從我們和第三方接收營銷的偏好、您的通信偏好以及與我們、我們的服務提供商和其他第三方的通信歷史；",
    "policy_tit3info1li11": "地理或位置數據；",
    "policy_tit3info1li12": "當您訪問、訪問我們或網站並與之互動時提供的關於您的任何其他信息；",
    "policy_tit3info1li13": "匯總有關您參與的內容的數據。",
    "policy_tit3info2": "3.2 您同意不向我們提交任何不准確或具有誤導性的信息，並且您同意將此類信息的任何不准確或變更通知我們。我們保留要求提供進一步文件以驗證您提供的任何信息的權利。",
    "policy_tit3info3": "3.3 如果您使用您的社交媒體帳戶（“社交媒體帳戶”）註冊為我們平台的用戶，將您的{name}帳戶鏈接到您的社交媒體帳戶或使用任何{name}，我們可能會訪問您的信息 社交媒體功能已根據此類提供商的政策自願提供給您的社交媒體帳戶提供商。任何此類個人數據將始終根據本政策進行管理和使用。",
    "policy_tit3info4": "3.4 如果您不希望我們收集上述信息/個人數據，您可以通過書面通知我們的數據保護官選擇退出。有關選擇退出的更多信息，請參閱下面標題為“您如何撤回您的同意、刪除、請求訪問或修改您提供給我們的信息？”的部分。但請注意，選擇退出或撤銷您對我們收集、使用或處理您的個人數據的同意可能會影響您對服務和平台的使用。例如，選擇退出位置信息收集將導致其基於位置的功能被禁用。",
    "policy_tit4": "4 其他資料的收集",
    "policy_tit4info1": "4.1. 與大多數網站和移動應用程序一樣，您的設備發送的信息可能包括您瀏覽我們網站時由網絡服務器記錄的有關您的數據。它通常包括但不限於您的互聯網協議 (IP) 地址、計算機/移動設備操作系統和瀏覽器類型、移動設備類型、移動設備的特性、唯一設備標識符 (UDID) 或移動設備標識符 (MEID) ) 對於您的移動設備，推薦網站的地址（如果有），以及您在我們網站和移動應用程序上訪問的頁面和訪問時間，有時還有“cookie”（可以使用您的瀏覽器首選項禁用） 幫助網站記住您上次訪問。這些信息也包含在匿名統計中，以便我們了解訪問者如何使用我們的網站。",
    "policy_tit4info2": "4.2. 我們的移動應用程序可能會使用 GPS、Wi-Fi 等技術收集有關您移動設備位置的精確信息。我們出於一個或多個目的收集、使用、披露和處理此信息，包括但不限於您請求的基於位置的服務，以便根據您的位置向您提供相關內容或允許您與其他用戶共享您的位置 我們移動應用程序下的部分服務。對於大多數移動設備，您可以通過您的設備設置撤銷您對我們獲取您位置信息的許可。如果您對禁用移動設備的定位服務有任何疑問，請隨時聯繫您的設備服務提供商或製造商。",
    "policy_tit4info3": "4.3. 在某些情況下，我們可能會在當地法律允許或徵得您同意的情況下收集某些類型的敏感信息，例如健康/醫療信息（包括殘疾狀況）、工會會員信息、宗教、種族或族裔以及犯罪信息 定罪和罪行。此類信息的收集和使用僅用於特定目的並在法律允許的情況下進行，例如進行背景調查或遵守適用的政策和法律義務。",
    "policy_tit5": "5 Cookies",
    "policy_tit5info1": "5.1. 我們或我們的授權服務提供商和廣告合作夥伴可能會偶爾使用“cookies”或其他功能來允許我們或第三方收集或共享有關您使用我們網站或服務的信息。這些功能有助於我們改進我們的網站和我們提供的服務，並使我們的廣告合作夥伴和我們能夠為您提供更多相關內容，包括通過再營銷。 “Cookie”是存儲在您的計算機或移動設備上的標識符，用於記錄有關計算機或設備的數據、使用或訪問網站的方式和時間、有多少人以及我們網站內的其他活動。我們可能會將 cookie 信息鏈接到個人數據，並且 cookie 還會鏈接到有關您瀏覽過哪些網頁的信息。這些信息旨在根據您的興趣提供內容，使我們的第三方廣告合作夥伴能夠在互聯網上的網站上投放廣告、進行數據分析並監控網站的使用情況。",
    "policy_tit5info2": "5.2. 您可以通過在瀏覽器上選擇適當的設置來拒絕使用 cookie。但是，請注意，如果您這樣做，您可能無法使用和訪問我們網站的全部功能。請注意，基於 cookie 的選擇退出在移動應用程序上可能無效。但是，您可以按照 Android 和 iOS 的說明選擇退出某些移動應用程序上的個性化廣告。",
    "policy_tit6": "6 我們如何使用您提供給我們的信息？",
    "policy_tit6info1": "6.1. 我們可能出於以下一項或多項目的收集、使用、披露和處理您的個人數據：",
    "policy_tit6info1info1": "考慮並處理您的申請；",
    "policy_tit6info1info2": "向您提供您可能感興趣的工作機會，包括與{name}及其關聯公司或相關公司的工作機會；",
    "policy_tit6info1info3": "管理、運營、提供和管理網站的使用；",
    "policy_tit6info1info4": "通過為您提供向我們提交信息的快速方法來定制您的體驗；",
    "policy_tit6info1info5": "執行我們的服務條款或任何適用的最終用戶許可協議；",
    "policy_tit6info1info6": "保護人身安全以及我們自己、我們的員工和他人的權利、財產或安全；",
    "policy_tit6info1info7": "用於識別和驗證；",
    "policy_tit6info1info8": "維護和管理可能不時需要的任何軟件更新和其他更新和支持，以確保網站的順利運行；",
    "policy_tit6info1info9": "處理或回應您（或聲稱來自）您的任何詢問；",
    "policy_tit6info1info10": "通過語音電話、短信、傳真、電子郵件和郵政郵件與您聯繫或溝通有關就業機會的信息，以管理網站並提供與網站管理相關的信息。您承認並同意，這種通信方式可能涉及通過在信封/郵件包裹的外殼上包含信息來披露有關您的特定個人數據；",
    "policy_tit6info1info11": "進行研究、分析和開發活動（包括但不限於數據分析、調查、技術開發和分析）以分析您如何使用網站，以改進和增強網站；",
    "policy_tit6info1info12": "允許進行審計和調查，以驗證我們目標受眾的規模和構成，並了解他們對網站的體驗；",
    "policy_tit6info1info13": "用於市場營銷，並在這方面向您發送與{name}及其附屬公司或相關公司可能擁有的工作機會相關的信息和材料，無論此類工作列表現在是否存在或將來通過郵寄或電子郵件創建。您可以隨時使用營銷材料中的取消訂閱功能取消訂閱接收營銷信息。我們，只要我們的關聯公司可能會使用您的聯繫信息來發送新聞通訊或營銷材料；",
    "policy_tit6info1info14": "響應法律程序或遵守任何相關司法管轄區的任何適用法律、政府或監管要求或我們真誠地認為此類披露是必要的，包括但不限於滿足披露要求 任何對{name}或其相關公司或附屬公司具有約束力的法律要求或對法律索賠的回應；",
    "policy_tit6info1info15": "為內部和法定報告和記錄保存要求提供統計數據和研究；",
    "policy_tit6info1info16": "根據法律或監管義務或法律可能要求或我們可能已製定的風險管理程序進行盡職調查或其他篩選活動（包括但不限於背景調查）；",
    "policy_tit6info1info17": "在適用的情況下，與您建立僱傭關係並執行和管理任何相關的義務、福利和政策；",
    "policy_tit6info1info18": "審核我們的網站； 防止或調查任何欺詐、非法活動、遺漏或不當行為，無論是否與您使用本網站或因您與我們的關係而產生的任何其他事項有關，以及是否對上述情況有任何懷疑；",
    "policy_tit6info1info19": "存儲、託管和備份（無論是用於災難恢復還是其他）您的個人數據，無論是在您的管轄範圍內還是在管轄範圍外；",
    "policy_tit6info1info20": "我們在徵得您同意時通知您的任何其他目的。 （統稱為“目的”）。",
    "policy_tit6info2": "6.2. 由於我們將/可能收集、使用、披露或處理您的個人數據的目的取決於手頭的情況，此類目的可能不會出現在上面。但是，除非隱私法允許在未經您許可的情況下處理適用數據，否則我們會在徵得您同意後通知您此類其他目的。",
    "policy_tit6info3": "6.3. 您承認、同意並同意我們可以訪問、保存和披露您的個人信息和內容，如果法律要求或根據法院命令或任何對 {name} 或其關聯公司具有管轄權的政府或監管機構或 真誠地相信此類訪問保護或披露對於以下方面是合理必要的：(a) 遵守法律程序； (b) 遵守對{name}或其相關附屬公司具有管轄權的任何政府或監管機構的要求； (c) 執行我們的服務條款或本隱私政策； (d) 回應針對 {name} 或其相關附屬公司提出的任何威脅或實際索賠，或任何內容侵犯第三方權利的其他索賠； (e) 響應您的客戶服務請求； (f) 保護{name}或其相關關聯公司、其用戶和公眾的權利、財產或人身安全。",
    "policy_tit7": "7 我們保留哪些信息，{name}如何保護用戶信息？",
    "policy_tit7info1": "7.1. 我們實施各種物理、管理和電子安全措施，以確保您的個人數據在我們系統上的合理安全。用戶個人數據包含在安全網絡之後，只有少數擁有此類系統特殊訪問權限的員工才能訪問。",
    "policy_tit7info2": "7.2. 我們將根據隱私法和其他適用法律保留個人數據，包括為實現收集數據的目的、提供我們的服務、解決糾紛、建立法律防禦、追求合法的商業目的、執行我們的協議所必需的， 遵守適用法律，包括保持準確的就業、工資、稅收或其他記錄。也就是說，當我們合理確定 (i) 我們與您不再有關係，(ii) 保留此類個人數據不再符合保留該個人數據的目的時，我們將銷毀或匿名化您的個人數據 集; (iii) 出於任何法律或商業目的不再需要保留。如果您撤回就業申請、停止使用本網站，或者您訪問或使用本網站的許可被終止，以及以其他方式終止您與我們的關係，我們可能會根據本隱私政策和我們的義務繼續存儲、使用和披露您的個人數據 根據隱私法。根據適用法律，我們可能會安全地處理您的個人數據，恕不另行通知。",
    "policy_tit8": "8 {name} 是否向外部各方披露從訪問者那裡收集的信息？",
    "policy_tit8info1": "8.1 在開展我們的業務過程中，我們將/可能需要使用、處理、披露和轉移您的個人數據給我們的第三方服務提供商、代理商和我們的關聯公司或關聯公司及其他第三方； 這些第三方可能位於新加坡境內或境外，用於上述一項或多項目的。這些第三方服務提供商、代理人、關聯公司、關聯公司和其他第三方將代表我們或以其他方式處理您的個人數據，以實現上述一個或多個目的。我們努力確保第三方和我們的關聯公司保護您的個人數據免受未經授權的訪問、收集、使用、披露、處理或類似風險。我們僅在上述目的個人數據所需的期限內保留您的個人數據。這些第三方包括但不限於：",
    "policy_tit8info1li1": "我們的子公司、關聯公司和關聯公司。",
    "policy_tit8info1li2": "您在平台上與之交易或互動的買家或賣家，或與您出於上述目的使用服務相關的買家或賣家。",
    "policy_tit8info1li3": "出於上述一項或多項目的使用我們平台的其他用戶。",
    "policy_tit8info1li4": "承包商、代理商、服務提供商和我們用來支持我們業務的其他第三方。這些包括但不限於為我們提供行政或其他服務的人員，例如郵寄公司、物流服務提供商、金融服務提供商、廣告和營銷合作夥伴、電信公司、信息技術公司和數據中心。",
    "policy_tit8info1li5": "對 {name} 具有管轄權或第 6.2 條允許的其他政府或監管機構。",
    "policy_tit8info1li6": "在合併、剝離、重組、解散或其他出售或轉讓部分或全部{name}資產（無論是作為持續經營還是作為破產、清算或類似程序的一部分）的情況下的買方或其他繼承人， 其中 {name} 持有關於我們的服務用戶的個人數據是一項資產轉移； 或涉及{name}或其任何附屬公司或相關公司的商業資產交易的一方；",
    "policy_tit8info1li7": "我們為一個或多個目的向其披露的第三方，這些第三方又為一個或多個目的收集和處理您的個人數據。",
    "policy_tit8info2": "8.2 我們可能會與廣告合作夥伴和第三方廣告、再營銷和其他程序提供商共享用戶信息，包括統計和人口統計數據，以及有關他們使用服務的信息。",
    "policy_tit8info3": "8.3 為免生疑問，如果隱私法或其他適用法律允許我們等組織在未經您同意的情況下收集、使用或披露您的個人數據，則該法律授予的許可將繼續適用。與上述一致，根據適用法律，我們可能出於公認的法律原因使用您的個人數據，包括遵守我們的法律義務、履行我們與您簽訂的合同以及合法權益。我們使用這些理由來抵消對您的數據保護權利造成的任何損害，或者在必要時與法律索賠有關。",
    "policy_tit8info4": "8.4 第三方可能會非法攔截或訪問傳輸到本網站或包含在本網站上的個人數據，技術可能會發生故障或無法按預期工作，或者信息可能會因我們的過失而被未經授權的人訪問、濫用或誤用。但是，我們將按照《隱私法》的要求部署合理的安全措施來保護您的個人數據； 但是，無法保證絕對安全，例如但不限於，當惡意和老練的黑客非我們的過錯導致未經授權的披露時。",
    "policy_tit8info5": "8.5 {name} 允許您在 {name} 直播功能中分享來自 YouTube 的視頻（“YouTube 內容”）。為此，{name} 使用了 YouTube 提供的 YouTube API 服務。使用共享 YouTube 內容，即表示您特此同意受位於 http://www.google.com/policies/privacy 的 Google 隱私政策的約束。",
    "policy_tit8info6": "8.6 如{name}服務條款所述，用戶（包括任何員工、代理人、代表或代表該用戶或代表該用戶的任何其他人）通過使用服務擁有另一用戶的個人數據（ “接收方”）特此同意他們將遵守適用於任何此類數據的所有隱私法，包括此類數據的任何收集、處理、存儲或傳輸。",
    "policy_tit8info7": "8.7 儘管此處有任何規定，賣方（包括任何僱員、代理人、代表或代表該用戶行事或代表該用戶的任何其他人）應遵守與從{name}收到的任何買方信息相關的所有適用隱私法。",
    "policy_tit8info7_1": "8.7.1 未經買方和{name}事先書面同意，不得使用買方的個人數據，除非為回應買方的詢問以及回應、處理、處理或完成交易而合理必要。應避免使用此類信息聯繫 {name} 平台以外的買家。",
    "policy_tit8info7_2": "8.7.2 未經買方和{name}事先書面同意，{name}平台不會向任何未經授權的第三方披露買方的個人資料。",
    "policy_tit8info7_3": "8.7.3 {name}平台將採取充分的安全措施保護其持有的每個{name}用戶的個人數據，僅在上述目的和隱私法規定的必要期限內保留數據，並刪除或 應 {name} 的任何要求或在交易完成後的合理時間內將數據返回給 {name}，並在發生任何潛在的數據洩露或此類用戶數據的其他丟失時通知 {name} 的個人數據保護官。",
    "policy_tit8tit9": "9 我們對兒童的政策",
    "policy_tit8tit9info1": "服務不適用於 13 歲以下的兒童。我們不會有意收集或維護 13 歲以下任何人的個人數據或非個人身份信息，我們平台的任何部分也不針對 13 歲以下的兒童。我們將刪除和刪除任何個人信息 我們認為數據是由 13 歲以下的任何兒童提交的。在某些司法管轄區，根據適用法律，年齡限制可能更高，在這種情況下，我們遵守適用的年齡限制。",
    "policy_tit8tit10": "10 第三方收集的信息",
    "policy_tit8tit10info1": "10.1 我們的平台使用 Google Analytics，這是 Google, Inc.（“Google”）提供的一種網絡分析服務。 Google Analytics 使用 cookie（放置在您設備上的文本文件）幫助平台分析用戶如何使用平台。由 cookie 生成的關於您使用平台的信息（包括您的 IP 地址）將被傳輸並存儲在谷歌位於美國的服務器上。谷歌將使用這些信息來評估您對平台的使用，為網站運營商編制網站活動報告，並提供與網站活動和互聯網使用相關的其他服務。谷歌也可能會在法律要求或此類第三方代表谷歌處理信息的情況下將此信息傳輸給第三方。",
    "policy_tit8tit10info2": "10.2 有時，第三方和我們可能會通過平台或服務提供軟件應用程序下載供您使用。這些應用程序可能會單獨訪問並允許第三方查看您的個人身份信息，例如您的姓名、您的用戶 ID、您設備的 IP 地址或其他信息，例如您之前可能已經安裝或通過以下方式為您安裝的任何 cookie 第三方軟件應用程序或網站。此外，這些應用程序可能會要求您直接向第三方提供額外信息。通過這些應用程序提供的第三方產品或服務不由 {name} 所有或控制。我們鼓勵您閱讀此類第三方在其網站或其他地方發布的條款和其他政策。",
    "policy_tit8tit11": "11 關於安全和第三方網站的免責聲明",
    "policy_tit8tit11info1": "11.1 我們不保證您在第三方網站上提供的個人數據和其他信息的安全。我們實施各種安全措施來維護我們擁有或控制的您的個人數據的安全。您的個人數據包含在安全網絡之後，只有少數擁有此類系統特殊訪問權限的人才能訪問，我們對個人數據保密。當您訪問您的個人數據時，我們會提供一個安全的服務器。您提供的所有個人數據或敏感信息都被加密到我們的數據庫中，並且只能按照上述方式訪問。",
    "policy_tit8tit11info2": "11.2 為了提供增值，我們可能會選擇各種第三方網站鏈接到網站並在網站內構建。這些鏈接的網站有單獨和獨立的隱私政策和安全安排。即使第三方與我們有關聯，我們也無法控制獨立於我們的這些鏈接網站、隱私和數據收集實踐。我們可能不會收到此類第三方網站收集的數據（即使在我們的網站上或通過我們的網站提供）。",
    "policy_tit8tit11info3": "11.3 因此，我們對這些鏈接網站的內容、安全安排（或缺乏安全安排）和活動不承擔任何責任或義務。這些鏈接的網站只是為了您的方便，因此您需要自行承擔訪問它們的風險。為了保護您的信息，我們建議您仔細閱讀您訪問的所有第三方服務的隱私政策。儘管如此，我們力求保護我們網站的完整性以及放置在每個網站上的鏈接。因此，我們歡迎對這些鏈接網站的任何反饋（包括但不限於特定鏈接是否有效）。",
    "policy_tit8tit12": "12 {name} 會將您的信息轉移到海外嗎？",
    "policy_tit8tit12info": "您的個人數據和信息可能會被傳輸到您所在國家/地區以外的國家/地區，並在這些國家/地區之外進行存儲或處理。您的大部分個人數據將在我們的服務器所在的英國處理，我們只會根據隱私法將您的信息傳輸到海外。",
    "policy_tit8tit13": "13 您如何撤回同意、請求訪問或更正您提供給我們的信息？",
    "policy_tit8tit13info": "13.1 撤回同意",
    "policy_tit8tit13info1": "13.1.1 您可以通過發送電子郵件至我們的個人數據保護官 {email} 撤回您對收集、使用和披露我們擁有或控制的您的個人數據的同意。但是，您撤回同意可能意味著我們無法繼續評估您的申請和您提供的任何信息。",
    "policy_tit8tit13info2": "13.1.2 當您分享 YouTube 內容時，除了根據第 13.1.1 條通過電子郵件撤回您對我們的同意外，您還可以使用 Google 安全設置頁面 https://security.google.com/settings/security/permissions , 撤銷 {name}Shop 對您的個人數據的訪問權限。",
    "policy_tit8tit13info3": "13.2. 訪問或更正個人數據的請求",
    "policy_tit8tit13info4": "13.2.1 如果您有我們的賬戶，您可以通過本平台的賬戶設置頁面親自訪問和更正我們目前持有或控制的您的個人資料。如果您沒有我們的帳戶，您可以通過向我們提交書面請求來請求訪問和更正我們目前擁有或控制的您的個人數據。我們需要您提供足夠的信息來確定您的身份和請求的性質，以便能夠處理您的請求。因此，請通過 {email} 將您的書面請求發送給我們的個人數據保護官。",
    "policy_tit8tit13info5": "13.2.2 我們可能會向您收取合理的費用來處理您訪問您的個人數據的請求。如果我們選擇收費，我們將向您提供我們將收取的費用的書面估算。請注意，除非您同意支付費用，否則我們無需回复或處理您的訪問請求。",
    "policy_tit8tit13info6": "13.2.3 我們保留根據《隱私法》的規定拒絕更正您的個人數據的權利，該法要求並授權組織在所述情況下拒絕更正個人數據。",
    "policy_tit8tit14": "14 其他問題、疑慮或投訴",
    "policy_tit8tit14info": "如果您對我們的隱私慣例有任何疑問或疑慮，請隨時通過 {email} 與我們聯繫。",
    "policy_tit8tit14info_1": "請包括您的姓名、聯繫信息和請求的性質，以便我們能夠適當地回复您的來信。",
    "delivery_title": "送貨和取貨",
    "delivery_q1": "你在哪里送貨？",
    "delivery_d1": "要了解我們是否運送到您所在的地區，請在您要購買的商品上輸入您的郵政編碼。產品直接從我們的供應商處發貨，我們的全球倉庫遍布 {num} 個國家/地區。",
    "delivery_q2": "去哪裡取？",
    "delivery_d2": "我們在 {name}Shop 商店、Sainsbury's 超市和全球倉庫的收集點全天候 24/7 運營。",
    "delivery_d2_1": "對於可用於快速通道交付的物品，請根據您所在的位置從多個時間段中進行選擇。訂單將送貨上門並存放在安全可靠的地方。",
    "delivery_d2_2": "英格蘭、蘇格蘭和威爾士提供大型和笨重物品（需要兩人或多人搬運的物品，例如沙發和床），因此我們可以將它們安全地運送到您選擇的任何地方。我們友好的司機之一將在同一天與您聯繫，討論送貨細節。如果您正在自我隔離，請告知我們，以便我們重新安排您的交貨日期。",
    "delivery_d2_2_int": "美國提供大型和笨重物品（需要兩人或多人搬運的物品，例如沙發和床），因此我們可以將它們安全地運送到您選擇的任何地方。 我們友好的司機之一將在同一天與您聯繫，討論送貨細節。 如果您正在自我隔離，請告知我們，以便我們重新安排您的交貨日期。",
    "delivery_d2_3": "我們目前對大件物品的交付有很高的需求。如果您的交貨延遲，我們會盡快給您發送消息。我們正在努力為我們的客戶提供最好的服務，感謝您一直以來的耐心和支持。",
    "delivery_tit": "常見問題",
    "delivery_q3": "如果我同時訂購大件和小件商品怎麼辦？",
    "delivery_d3": "將它們送到您手中的最快方式是單獨運送。不用擔心; 您只需支付一次運費。請查看您的訂單確認電子郵件以獲取更多信息。",
    "delivery_q4": "如果我不在家怎麼辦？",
    "delivery_d4": "小物品將留在安全可靠的地方，在看不見的地方，或應您的要求交給您的鄰居。大件或貴重物品需要照片或簽名且不能留下，因此必須有人在家領取。如果您無法趕到，請通過幫助熱線聯繫我們，以便我們重新安排送貨時間並選擇最適合您的日期和時間段！",
    "delivery_q5": "有多少人運送大件物品？",
    "delivery_d5": "大件物品，如沙發、冰櫃等，可以兩人送貨。我們友好的司機將在送貨當天與您聯繫，並將您的訂單安全地送至您選擇的地點。",
    "delivery_q6": "COVID-19：對交付的影響？",
    "delivery_d6": "我們仍然提供許多商品的送貨服務，包括我們的遊戲機預購。當交貨日期臨近時，您將收到我們的短信提醒，並在交貨前收到快遞員的跟踪號碼。",
    "delivery_d7": "貨物將在安全區域送貨上門； 大件物品將被運送到安全的地方。我們友好的司機之一將在同一天與您聯繫，討論大件物品的運輸細節。如果您正在自我隔離，請告知我們，以便我們重新安排您的交貨日期。",
    "returnPolicy_title": "退貨、產品支持和維修",
    "returnPolicy_tit1": "我改變主意了",
    "职业机会": "職業機會",
    '签名成功': '簽名成功', 
    
    // "请输入用户名": ""
    安卓下载: '下載安卓版',
    苹果下载: '下載蘋果版',
    "returnPolicy_tit1info": "您可以在取貨或送貨後 15 天內退貨。",
    "returnPolicy_tit1info1": "您的物品必須是：",
    "returnPolicy_tit1li1": "未使用且具有所有原始組件；",
    "returnPolicy_tit1li2": "在原始包裝中（如果適用，帶有標籤）；",
    "returnPolicy_tit1li3": "處於轉售狀態；",
    "returnPolicy_tit1li4": "有購買憑證；",
    "returnPolicy_tit1info2": "與產品隨附的任何贈品一起使用。",
    "returnPolicy_tit1info3": "退款將通過原始付款方式處理。如果您使用 USDT 或 ETH，需要一個工作日才能顯示在您的賬戶中； 使用銀行電匯，退款最多可能需要 30 天，具體取決於您的銀行。",
    "returnPolicy_tit2": "產品支持",
    "returnPolicy_tit2info": "在大多數情況下，如果您有任何物品問題，您可以在家中舒適地查看我們的產品支持網站，看看我們是否可以解決問題。在那裡，您可以訪問有關產品和我們公司的常見問題解答、運輸和取件、退貨和退款。",
    "returnPolicy_tit3": "我的貨物有問題",
    "returnPolicy_tit3info": "如果您仍然需要退貨（前 15 天內），我們將為您提供換貨、更換或退款。",
    "returnPolicy_tit3info1": "在此期限之後，只要產品仍在保修期內，我們將使用我們的專業維修代理安排維修，或者，如果無法維修，則更換或更換您的商品。最快的退貨方式是通過我們位於 {num} 個國家/地區的全球倉儲中心。我們可以接受除大件物品外的大多數物品，即使它們最初是送貨上門的。找到離您最近的商店。如果您要退回大件商品，請向下滾動以開始實時聊天或前往我們的幫助熱線鏈接。",
    "returnPolicy_tit4": "防範措施：",
    "returnPolicy_tit4info": "某些商品，如食品、穿孔首飾和內衣，只有在有缺陷的情況下才能換貨或退款。我們的網站將指明哪些項目不可退款。",
    "returnPolicy_tit4li1": "如果您退回 DVD、音樂或軟件產品，它們必須是未使用過的並且處於原始密封包裝中。",
    "returnPolicy_tit4li2": "如果商品或包裝嚴重損壞，我們保留減少退款金額的權利。",
    "returnPolicy_tit4li3": "我們可能會要求提供產品序列號或類似信息，以檢查我們是否提供了該物品。",
    "returnPolicy_tit4li4": "當然，這些都不會影響您的消費者權益。",
    "returnPolicy_titinfo1": "如果我們收取您的貨物，我們將在退款前檢查它們。請注意，如果商品已檢查但未按說明退回，我們保留根據退回商品的情況拒絕退款或提供部分退款的權利。",
    "returnPolicy_tit5": "常見問題",
    "returnPolicy_tit5q1": "我的退款需要多長時間？",
    "returnPolicy_tit5d1": "如果您將商品退回 {name} 商店，我們可以立即退款。需要一個工作日才能將其處理到您的帳戶中。如果您通過銀行電匯付款，您將通過銀行電匯方式獲得退款，這可能需要 30 天，具體取決於您的銀行。",
    "returnPolicy_tit5d1p": "如果您通過郵寄方式退貨，請最多等待兩週。我們將在收到後立即開始退款。最多可能需要一個工作日才能顯示在您的帳戶中。一旦處理完畢，我們將無法跟踪退款的進度，但請不要擔心； 處理後您會收到確認！",
    "returnPolicy_tit5d1p1": "請記住，所有退回的商品都必須符合我們的退貨政策，並且必須在原始包裝中未使用並提供購買證明。",
    "returnPolicy_titq2": "什麼才算是購買憑證？",
    "returnPolicy_titq2p": "這些證明在 {name} 購買：",
    "returnPolicy_titd2li1": "收銀機收據；",
    "returnPolicy_titd2li2": "電子收據；",
    "returnPolicy_titd2li3": "您的訂單號；",
    "returnPolicy_titd2li4": "電子郵件確認。",
    "returnPolicy_titd2info": "如果您找不到以上任何內容，請不要擔心。如果您有以下問題，我們應該能夠解決任何問題：",
    "returnPolicy_titd2li5": "您的交易賬單；",
    "returnPolicy_titd2li6": "用於購買商品的電子郵件地址。",
    "returnPolicy_titq3": "如果沒有問題，我可以退貨嗎？",
    "returnPolicy_titd3": "根據我們的退貨政策，該產品可以退回任何{name}商店。"
    ,
    footer_getCoupons: '獲得您更多的優惠券',
    '商户签名错误': '商戶簽名錯誤',
    '图片不能为空': '圖片不能為空',
    '模块名不能为空': '模塊名不能為空',
    '图片大小不能超过4M': '圖片大小不能超過4M',
    '文件上传失败': '文件上傳失敗',
    '服务器错误': '服務器錯誤',
    '邮箱格式不正确！': '郵箱格式不正確！',
    footer_yourEmail: '您的電子郵箱',
    footer_subscription: '訂閱',
    footer_paymethods: '支付方式',
    footer_footdec: '{name}全球站的用戶來自全球{num}個國家，使用{coin}進行結算。 {coin}是一種無國界的交易方式，可以在全球範圍內實現即時低成本交易，無需等待，沒有國際費用。',
    footer_custService: '客戶服務',
    footer_helpLine: "在線客服",
    footer_contactUs: '聯繫我們',
    footer_partner: '合作供應商',
    footer_buyRules: '買家規則',
    footer_sellerRules: '賣家政策',
    footer_returnsAndEx: '退貨和換貨',
    footer_servicePolicy: '服務政策',
    footer_return1Policy: '退貨政策',
    footer_user_Center: '用戶中心',
    footer_userReg: '用戶註冊',
    footer_orderTrack: '訂單查詢',
    footer_purchageHistory: '商品收藏',
    footer_myPurse: "我的錢包",
    footer_aboutUs: '關於我們',
    footer_Recruitment: '招賢納士',
    footer_news: "新聞資訊",
    footer_stateMent: "現代奴隸聲明",
    footer_binance: "Binance",
    footer_huobi: "Huobi",
    footer_okx: "okx",
    footer_privacyPolicy: '隱私政策',
    footer_businessPhone: '企業電話',
    footer_businessEmail: '企業郵箱',
    footer_your1Email: '您的電子郵箱',
    footer_emailTips: '請填寫正確的郵箱地址！',
    footer_subSucc: '訂閱成功！',
    footer_delivery: '送貨及取貨',
    footer_footTip: '{name} 有限公司2023 版權所有',
    footer_footTips: "{name} Limited 作為信貸經紀人 (713206) 獲得金融行為監管局的授權和監管，並專門與貸方 Home Retail Group Card Services Limited 合作，以 {name} Financial Services 的身份進行交易，{name} Financial Services 獲得金融行為監管局的授權和監管以提供信貸(716148)。 Home Retail Group Card Services Limited 註冊於英國 (04007072)，地址為 Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom。 MK9 2NW。",
    "Please fill in the correct email address!": "請填寫正確的郵箱地址！",
    "SUBSCRIBE SUCCESSFULLY!": "訂閱成功！",
    "邮箱的长度不能超过64个字符": "郵箱的長度不能超過64個字符",
    about_title:"MetaShop簡介",
    about_info1:"MetaShop成立於2016年，MetaShop是英國MetaShop集團跨境電商平台，屬於英國的新秀藍海，同時也是發展速度最快的跨境電商平台。",
    about_info2:"MetaShop致力於通過商業和科技促進英國本土以外，以歐洲、南美、亞太以及中東等發展中地區市場發展。 MetaShop是一家無貨源跨境電商平台，注重市場潛力高，能夠搶占先機的 發展中地區的藍海跨境市場，幫助中小企業和個人邁出出海貿易成功的第一 步。 MetaShop平台絕非簡單的中介，而是提供高附加值服務的電商渠道機構， 是一個擁有客戶管理、信息反饋、數據庫管理、決策支持等功能的服務平台， 最終才能打造成一個完善無貨源的跨境電商系統。 MetaShop的目的是通過統一的經營管理 對商品和服務、消費者終端同時進行整合，是廣大供應商、店鋪和消費者之間的橋樑，為供應商和消費者提供最優質的服務",
    about_info3:"英國MetaShop公司（簡稱：MetaShop）2021年7月宣布完成3500萬英鎊的A+輪融資，隨著此次募款的結束，MetaShop 期待在未來一到兩年內實現進一步的擴張，其中包括開發消費者應用程序、改進產品基礎設施、推進新的戰略合作以及實現更大範圍的全球擴張。在短期內實現12倍的年總交易金額增長後，MetaShop的下一步計劃是在這輪融資後一到兩年實現獨角獸地位。",
    "about_info4": "Fuel Ventures 以 650 萬英鎊的投前估值投資於 MetaShop，僅在 18 個月內估值就已經上漲了 14.18 倍（稀釋後）。這是Fuel Ventures投資組合中增長最快的公司之一。",
        "about_info5": "成立於2016年，MetaShop是一家在短期內實現高速增長的B2C，零庫存，全面透明的電子商務平台。",
        "about_info6": "MetaShop 不持有庫存或銷售任何可能與賣家競爭的自有產品，收取的佣金也低於其他平台，從而降低價格以吸引更多的消費者。",
        "about_info7": "不到10年間，Fuel Ventures的投資幾乎覆蓋全產業鏈。 Fuel Ventures 的團隊是超過 47 家發展最快的初創科技公司的投資者，其中包括 Paddle，英國發展最快的軟件公司之一。",
        "about_info8": "在過去的一年中，MetaShop的銷售額實現了近9倍的增長， MetaShop 還成為了繼eBay後唯一構建和 PayPal合作的市場平台：Paypal將為買家和賣家提供額外的保護，並縮短物品發貨時收款所需的時間。",
        "about_info9": "MetaShop 已經在1500 億英鎊的英國電商市場有所建樹，但是以長期戰略佈局來說，MetaShop的目標是4.5 兆億英鎊的全球市場。他們下一步的計劃是將MetaShop平台推廣到超過42個國家， MetaShop在英國市場的成功也將為他們外國拓展計劃奠定基礎。",
        "about_info10": "穩紮穩打，為買家和賣家實現創造價值",
        "about_info11": "在短時間內實現 12倍 的總商品銷售額（GMV）增長和1560萬英鎊的年總商品銷售額(GMV)，MetaShop 未來的潛力是毋庸置疑的。",
        "about_info12": "MetaShop 的增長會很大程度使賣家受益：MetaShop 不是零售商，因此不斷增長的市場份額都將轉化為賣家的銷售額。",
        "about_info13": "MetaShop沒有忘記自己的初衷是為賣家和買家提供雙贏，在高速增長的同時，MetaShop也在與營銷合作合作夥伴，例如 Google 和 Bing，積極推銷賣家的產品以提高曝光率，以確保最大的可見性同時發展忠實的有機客戶群",
        "about_info14": "MetaShop 的創始人 Cas Paton是在幫助初創公司快速實現增長和優化隱藏價值方面的專家，他多年的電商工作經歷也使他創業路上受益匪淺，推動MetaShop在短時間內成為英國最大的市場平台。",
        "about_info15": "不可複制的高速增長模式",
        "about_info16": "雖然MetaShop進入B2C賽道的時間較晚，但是MetaShop在短時間實現的增長是不可複制的。即使和成功的電商比較，MetaShop在早期總銷售商品額（GMV）上的快速增長是不可匹敵的。",
        "about_info17": "從2018年到2019年，MetaShop實現了12倍的增長；阿里巴巴在早期2012年到2013年的同比數字增長也只是4倍。 MetaShop在總投資僅為800萬英鎊的情況下，已增長到 1.55 億英鎊的GMV，未來增長更是不可限量。在市場平台同類競爭者中，MetaShop的競爭優勢是明顯的，作為一個完全透明的平台，MetaShop致力於為買家和賣家提供更多優惠，通過低價來吸引更多的客戶。",
        "about_info18": "投資人：MetaShop的高速增長讓我們充滿信心",
        "about_info19": "Knut Frngsmyr，Klarna的副首席執行官評論道：“在投資了 MetaShop 後，我一直對他們將客戶（買家和賣家）放在首位的方式印象深刻並受到啟發。在瞬息萬變的環境中，有時簡單性和公平性會佔上風。未來的增長機會MetaShop 和團隊都很棒，我很高興被邀請加入這個旅程。”",
        "about_info20": "此輪3500 萬英鎊的新投資，包括債務和股權的組合，將推動 MetaShop進一步快速增長，投資人十分有信心並堅定地將目光投向在未來幾年內MetaShop能夠達到獨角獸地位。",
        "about_info21": "本輪投資來自包括Fuel Ventures、Bring Ventures、Norway Post 風險投資部門、Guy Hands（Terra Firma Capital Partners 的創始人兼董事長）、Knut Frngsmyr（Klarna 的副首席執行官）和 Richard Goulding（Play.com 的創始人）等戰略投資者。",
        "about_info22": "關於Fuel Ventures",
        "about_info23": "Fuel Ventures於2014年創立，總部位於倫敦，全球業績領先於95%同業者，是英國最活躍的早期風險投資機構之一，也是英國前十的早期科技風險投資機構。專注投資全球領先的初創科技公司，團隊由多次成功退出的企業家們組成創業驅動基金，擁有50餘年經驗，退出總額超20億英鎊。",
        "about_info24": "Fuel Ventures團隊因其自身豐富的創業、投資和管理經驗，常年深耕積累起的廣泛的人脈和深厚的行業資源，對於創業企業、投資人都是可信賴的合作夥伴。",
        "about_info25": "英國投資的低稅收以及歷史高回報率也使得Fuel Ventures成為國內很多投資人的首選。",
        ab_tit :'Hive-關於我們',
        ab_Info: "蜂巢電子商務有限公司",
        ab_Info1: "根據《2006年公司法》成立為私人公司，公司股份有限，其註冊地點在英格蘭和威爾士。",
        ab_Info2: "公司地址：20 文洛克路 倫敦 英國 N1 7GU",
        ab_Info3:"公司法人：弗洛索斯夫人 雷扎特",
        
      ab_Info4:"控制的性質：直接或間接持有75%或以上的股份公司的股份。有權直接或間接地任命或任命罷免該公司董事會的多數成員。",
      ab_Info5:"一家以提供互聯網服務為主的綜合企業集團，目前總部位於英國倫敦。服務範圍包括網上批發採購、購物搜索引擎、區塊鍊和雲計算服務等，公司逐步探索，發展，滲透新的互聯網時代web3.0。從Web2電商邁向Web3電商，最先改變的是供給模式，也就是平台所能為用戶提供的商品、下單、評論、虛擬物品以及活動等基礎能力，這些能力包括底層技術和To C、To B。",
      ab_Info6:"web3.0時代即將到來，新型電商市場即將崛起，web3.0是一個立體的互聯網時代，在這個新的賽道，所有的互聯網企業將重新起跑。我們蜂巢電子商務有限公司，為了搶占市場先機，斥資扶持商戶初期入住平台創業。",
      ab_Info7:"'蜂巢電子商務有限公司'是集全球智能倉儲、電子商務與區塊鏈技術的創新融合的一家新興企業，通過新的電商生態領域web3.0佈局，構建了新型的電商平台'HIVE'。",
      ab_Info8:"'HIVE'更加註重跨國貿易，提高市場佔有率和降低成本；通過全球智能倉儲加強售後服務和物流配送等環節，大大縮減商家運營時間，提供多元化的產品和服務，提高消費群體的購物體驗；並通過人工智能、大數據等技術手段，實現精準化的營銷和客戶管理，提高企業的效率和競爭力；'蜂巢電子商務有限公司'著力打造'協同共享'為核心、打破企業邊界，深化企業分工協作，集數據鏈接、管理、調度數據資源的全新一代全球智能倉儲；並結合加密貨幣對“HIVE”的全新結算結構；通過基於區塊鏈DLT（分佈式賬本技術） 對跨境交易的運用，加快了“HIVE”交易速度、交易安全與交易便利性，增強客戶與新支付結算平台的體驗；構建和擴展區塊鍊網絡運用於'HIVE'全球支付系統。",
      ab_Info9:"'HIVE'平台是直播電商模式與傳統電商模式的結合，步入web3.0的敲門磚。能夠促進整個市場的公平和正規化。例如，用戶購物時不用再過多擔心店舖的信譽評價，驗證各種好評差評、是否刷單，因為信任問題在'上鍊'那一刻就已經解決了。電子合同提供身份認證、合同模板、電子印章、文件簽署、合同歸檔管理等服務，並通過區塊鏈存證，為合同數據提供雙保險，具有多方見證、防篡改、可追溯特點。",
      ab_Info10:"未來，'蜂巢電子商務有限公司'將根據市場需求不斷發展；再次地擁抱全球智能倉儲、電子商務、區塊鏈、加密貨幣和web3.0趨勢，推動'HIVE'及行業的持續發展。",
      '返回上一步':'上一步',
    //   '确认':'确认',
    同意并签名: '同意並簽名',
    '请签字后再提交': '請簽字後再提交',
    '您还未完成签字，请签字完成后保存': '您還未完成簽字，請簽字完成後保存',
    "公司照片": "公司照片",
    "营业执照": "營業執照",
    "两次输入的密码不相同":"兩次輸入的密碼不相同",
    "实名姓名不能为空":"實名姓名不能為空",
    "该邮箱已被占用，请更换其他邮箱注册":"該郵箱已被占用，請更換其他郵箱註冊",
    "推荐人无权限推荐":"推薦人無權限推薦",
    "用户名必须6-30位":"用戶名必須6-30位",
    'entTips': "Shop2u成立於2022年，是以區塊鏈技術面向全球市場打造的全新在線交易平台，主要通過Dropshipping模式在歐洲、美洲、非洲，澳大利亞市場銷售產品。作為全球最大的B2B跨境電商平台之一，累計服務70餘個國家和地區的超過2600萬活躍企業買家。全球範圍內每月訪問Shop2u的消費者超過2億，是大多數人們在網上選擇購物的主要平台。",
      capture_tit:'經營合同',
      capture_info: '雙方經友好協商，對於商城合作一事達成如下協議：',
      capture_info1: '合作期間：',
      capture_info2:'一、甲方責任',
      capture_info3:'1.甲方需提供足夠的供應商以及商品，用於合作。',
      capture_info4:'2.甲方需提供安全及運輸工作，以其一切工商稅務和運輸費用等。',
      capture_info5:'其包括：打包、安裝、售後、運輸、公共關係，等一切費用',
      capture_info6:'3.甲方需保證物流運輸的正常運行，並負責商品和工作人員的安全。',
      capture_info7:'如出現人為破壞，被盜，物品損壞，均由甲方全面負責，照價賠償。',
      capture_info8:'二、乙方責任',
      capture_info9:'1.乙方需提供商品成本、維護商城買家（客戶關係）。',
      capture_info10:'2.乙方保證良好的個人信用。',
      capture_info11:'3.乙方需{time}小時內及時處理訂單。',
      capture_info12:'三、違約條款',
      capture_info13:'1.如有特殊情況，經雙方協商協議解決。',
      capture_info14:'2.如受政策影響，特殊情況和經營狀態不好。乙方全權負責',
      capture_info15:'3.雙方必須嚴格遵守合同規定，如單方違約，任何一方需負法律責任或者賠償。',
      capture_info16:'4.即簽字之日起效。',
      capture_info17:'甲方：',
      capture_info18:'乙方：',
      capture_info19:'日期：',
      '重置':   '重置',
      's1':"產品的盈利",
      's2':"需要在{name}：全球上開設店鋪售賣他篩選的產品，對其進行上架，然後進行銷售",
      's3':"讓客戶在自己的商店上架貨物，然後等待有新訂單後處理訂單即可",
      's4':"平台會把同樣的物品在全球物價進行大數據分析比較之後，選擇同樣貨品中最便宜的進行售賣，為什麼叫做跨境電商，因為每個國家都有屬於本國的特色，價格也是不同，平台會選擇最優的商品供商家上架售賣",
      's5':"比如我們坐的椅子",
      's6':"美國 10美元",
      's7':"中東 5美金",
      's8':"中國 2美金",
        's9':"全球都是一樣的商品但是有更低的價格，有利可圖。",
        's10':"當平台篩選出可以上架的商品後，只需要向平台支付商品的成本價格，由平台對接供應商發貨，我們賺取的是跨境的差價",
        's11':"產品的運作方式",
        's12':"買家➡️下訂單，向平台支付購買商品的價格，確認收貨後平台會將錢轉入賣家商舖盈利",
        's13':"賣家➡️接訂單，向平台支付商品成本價，平台收到錢後向廠家支付成本價後發貨，買家確認收貨後，平台會將成本價和盈利轉入店鋪餘額中",
        's14':"廠家➡️安排發貨，當平台向廠家完成支付後，廠家安排發貨",
        's15':"產品的優勢",
        's16':"對比實體店鋪，{name}：的優勢，省錢，省心",
        's17':"省錢➡️是省去了很多不必要的費用，例如房租、倉庫租金、倉庫管理費、物流費。",
        's18':"省心➡️不需要囤貨，不需要備貨，不需要物流，一鍵代發，一鍵批發",
        's19':"對比其他電商平台，{name}：的優勢，低成本，高回報，0風險",
        's20':"低成本➡️0押金，0保證金，免月租，免倉儲",
        's21':"0風險➡️不需要囤貨，不需要任何前期費用，收到訂單處理訂單既可以完成盈利",
        "企业证明":'企業證明',
        '验证码已发送':'驗證碼已發送',
        "邮箱验证码发送次数过多，请明天再试":'邮箱驗證碼發送次數過多，請明天再試',
        "Ashopping-shippingPolicy-info": "（處罰/扣除規則）",
        "Ashopping-info": "簡介：這裡給大家介紹一下什麼是賣家評分系統、店鋪評分如何生成、評分持續時間等。",
        "Ashopping-info1-1": "適用站點：{name}",
        "Ashopping-info1-0": "適用站點：",
        "Ashopping-info1": "適用賣家：所有賣家",
        "Ashopping-title1": "1.如何進入賣家評分系統？",
        "Ashopping-title1info": "賣家評分系統鼓勵賣家保持高服務標準，從而為買家創造良好的購物體驗。",
        "Ashopping-title1info-1": "如果未達到績效目標，將扣分。",
        "Ashopping-title1info-2": "您可以在【賣家中心>>賣家信用評分】頁面查看我的評分，包括當前評分和處罰記錄。",
        "Ashopping-title1info-3": "詳細操作請參見如何保持良好的賬戶信用狀態。",
        "Ashopping-title2": "2. 評分是如何產生的？",
        "Ashopping-title2info": "如果未滿足買家的最低期望，則可能會產生積分。 同時，這也會提醒賣家仍然存在需要改進的問題。",
        "Ashopping-title2info-1": "賣家評分系統會在每個月的第一天根據賣家上個月的違規事項更新評分。 您可以點擊對應的評分維度關鍵字查看完整的政策。",
        "Ashopping-table1-header": "評分測量",
        "Ashopping-table1-header-1": "違規行為",
        "Ashopping-table1-header-2": "每月給出的分數",
        "Ashopping-table1-row": "訂單未完成率（Non-fulfillment rates，NFR）",
        "Ashopping-table1-row1": "延遲發貨率，LSR",
        "Ashopping-table1-row1-clo1": "近7天內取消或退回給賣家的訂單數量佔訂單總數的30%",
        "Ashopping-table1-row1-clo2": "近7天內賣家延遲超過72小時的訂單數量佔訂單總數的20%",
        "Ashopping-table1-row1-clo3": "最多 10 分",
        "Ashopping-table1-row2": "客戶服務",
        "Ashopping-table1-row2-clo1": "粗魯或辱罵性的聊天或評論",
        "Ashopping-table1-row2-clo2": "本月要求買家取消訂單超過3次",
        "Ashopping-table1-row2-clo3": "買家詢盤回复率低於80%",
        "Ashopping-table1-row2-clo4": "最多20分",
        "Ashopping-table1-row3": "違反承諾",
        "Ashopping-table1-row3-clo1": "賣家未按照承諾向買家提供服務，損害買家權益",
        "Ashopping-title3": "3. 得分對應的處罰是什麼？",
        "Ashopping-table2-tit": "如果賣家累積大量積分，則根據下表暫停賣家的部分銷售優惠：",
        "Ashopping-table2-header": "累計得分",
        "Ashopping-table2-header2": "處罰級別",
        "Ashopping-table2-j": "等級",
        "Ashopping-table2-row": "禁止參加 Argosshop 主題活動（28 天）",
        "Ashopping-table2-row1": "無法享受Argosshop運費或活動補貼（28天）",
        "Ashopping-table2-row2": "產品不會出現在瀏覽頁面中（28 天）",
        "Ashopping-table2-row3": "限制賣家貸款功能（28天）",
        "Ashopping-table2-row4": "不允許列表/修改（更改庫存除外）（28 天）",
        "Ashopping-table2-row5": "凍結賬戶（28天）",
        "Ashopping-table2-label": ">15後每3分",
        "Ashopping-title4": "客戶服務細則及實施細則",
        "Ashopping-title4-qs1": "1. 什麼是粗魯或辱罵性的聊天或評論？",
        "Ashopping-title4-d": "惡意騷擾是指會員對他人進行侮辱、咒罵、威脅、評論等言語攻擊或者通過邪惡手段騷擾他人，損害他人合法權益的行為。",
        "Ashopping-title4-qs2": "2. 如何處理粗魯或辱罵性的聊天或評論？",
        "Ashopping-title4-d1": "扣分（一般違規）、扣分（嚴重違規）、業務權限管控。",
        "Ashopping-title4-d2": "【適用情況】惡意騷擾是指會員對他人進行謾罵、咒罵、威脅等言語攻擊，或者採用不良手段騷擾他人，損害他人合法權益的行為。",
        "Ashopping-title5": "  對違反承諾採取的措施",
        "Ashopping-title5-qs": "什麼是違反承諾？",
        "Ashopping-title5-d": "【適用情況】違約是指賣家未按照承諾向買家提供服務，損害買家權益和/或未按照承諾履行對Argosshop的義務。 賣方必須繼續履行法定或約定的真實描述、換貨、退貨和退款",
        "Ashopping-title5-d1": "【處理措施】扣分（一般違規）",
        "Ashopping-title5-d1-tit": "【具體措施】",
        "Ashopping-title5-d1-tit-1": "（一）特殊情況下，賣家對已付款訂單或相應商品或服務有其他未履行承諾的，一般違規行為每次扣5分。",
        "Ashopping-title5-d1-tit-2": "（2）若賣家違反以下承諾，每項嚴重行為扣10分：",
        "Ashopping-title5-d1-tit-2-1": "1、ArgosShop判斷賣家確實應承擔退款等售後保障責任，但賣家拒絕承擔；",
        "Ashopping-title5-d1-tit-2-2": "2、ArgosShop判斷賣家確實應當承擔7天無理由退換貨的售後保證責任，但賣家拒絕承擔；",
        "Ashopping-title5-d1-tit-2-3": "3、未經買賣雙方協商，拒絕向買家發送或延遲發送承諾的試用貨；",
        "Ashopping-title5-d1-tit-2-4": "4. 付款訂單後72小時內賣家未處理訂單；",
        "Ashopping-title5-d1-tit-3": "（三）特別嚴重的",
        "Ashopping-title5-d1-tit-3-1": "1、參加Argosshop官方活動的賣家未能達到活動要求（發貨時間除外）；",
        "Ashopping-title5-d1-tit-3-2": "2.Argosshop（包括但不限於規則、規範、品類管理標準、行業標準等），上述行為符合具體情況的，按照規定執行。",
        "Ashopping-title5-d1-tit-3-3": "3、除上述行為外，Argosshop官方發布的其他管理內容（包括但不限於規則、規範、品類管理標準、行業標準等）構成違反承諾的，均按照其規定。",
        "Ashopping-title6": "4. 懲罰會持續多久？",
        "Ashopping-title6info": "處罰將於28天內結束。 只要採取適當措施，改善當前店鋪業績並保持其符合標準，被制裁的賣家將重新獲得一定的銷售特權。 另外，請在28天內將商店信用評分提升至100。",
        "Ashopping-title6info1": "各店鋪應遵守商場規則，規範經營。 只要採取相應措施改善現有店舖的業績並保持合規，被制裁的賣家將重新獲得一定的賣家權利。",
        "Ashopping-title6img1": "例1：賣家A在第3週獲得3分，第7週重新獲得權利",
        "Ashopping-title6img2": "示例 2：賣方 B 在第三週獲得 3 分，在第五週獲得 3 分。 累積兩點計算等級，第9週恢復權利",
        "Ashopping-title6img3": "例3：賣家C在新季度開始前一周獲得3分，在新季度開始後獲得3分，新獲得的積分將重新計算等級",
        "Ashopping-title7": "5. 違規行為的處理",
        "Ashopping-title7-1": "（1）一般情況：消費者提出投訴，Argosshop判斷投訴成立。 一般違規行為每次扣 5 分。 完成 5 個訂單可恢復 5 點。",
        "Ashopping-title7-2": "（2）情節嚴重的：消費者提出投訴，且Argosshop判斷投訴有理的，每嚴重一次扣20分。 完成20個訂單即可恢復20點。",
        "Ashopping-title7-3": "（3）情節特別嚴重的：賬戶將被凍結，28天內關閉店鋪。",
        "Ashopping-title8": "6. 如何提出評分上訴？",
        "Ashopping-title8-1": "單擊幫助熱線鏈接進行申訴。 如果您申訴成功，我們將取消您的評分並恢復您相應的賣家權利。",
        "Ashopping-shippingPolicy": "關於評分系統",
        "罚款 关店":  "罰款/關店",
        "恶意刷单": "惡意刷單",
        "商家雇佣或者使用本平台买家账户对本人账户下单以及多次下单": "商家雇傭或者使用本平台買家賬戶對本人賬戶下單以及多次下單",
        "卖家在过去7天内超过72小时延迟发货的订单数量占总订单数量的5%": "賣家在過去7天內超過72小時延遲發貨的訂單數量佔總訂單數量的5%",
        "卖家在过去7天内取消或退货退款订单数量占总订单的3%": "賣家在過去7天內取消或退貨退款訂單數量佔總訂單的3%",
        "企业电话": "企業電話",
        "客户端下载": "客戶端下載",
        "delivery_d2_Int":'我們位於 INT Overstock 商店和全球倉庫的收集點全天候 (24/7) 營運。',
        "tik_about1":"「激發創造，帶來愉悅」（Inspire Creativity and Bring Joy）」;總部位於洛杉磯和新加坡及辦公地點包括紐約、倫敦、都柏林、巴黎、杜拜、雅加達、首爾和東京的全球短視頻社交平台TikTok上線於 2017年，全球月活躍用戶數超過10億。",
        "tik_about2":"基於2022年TikTok電子商務業務的全球重組，TikTok擴大其線上零售批發業務，推出「TikTok-Wholesale」的新購物批發功能，透過TikTok在用戶流量、創意內容、興趣社群等方面的差異化優勢， 研發建立起行銷資源—外鏈合作—自主閉環—直播帶貨的獨立平台「TikTok-Wholesale」；「TikTok-Wholesale」透過全球雲端倉儲、全託管經營、新店導流推廣、數位貨幣結算結構、一 手機具可創業的獨有平台優勢；打破傳統電子商務業務市場局限，流量獲取難、供應鏈體係不完善、入駐冗長繁雜、競品無差異化、無獨立私域平台等一系列弊端；為 創業者提供行銷、經營一體化的解決方案。",
        "tit_about3":"「TikTok-Wholesale」將持續開發創新多元的行銷資源，為不同體量及發展階段的品牌借助 TikTok 平台深入本土、掌握商機，在全球實現品牌長效的建設及發展。",
}



























